// Thu Mar 27 06:04:36 GMT 2025

import * as models from "../crm-web-api-models"

export enum ClientProp {
	AssignedPoolName = 'assignedPool.name',
	AssignedUser = 'assignedUser',
	AvailableProducts = 'availableProducts',
	Blacklisted = 'blacklisted',
	BrandName = 'brand.name',
	CompanyRegulationCountryCompanyRegulationGracePeriodScoreLevels = 'companyRegulationCountry.companyRegulation.gracePeriodScoreLevels',
	ComplianceDataAllowDeposits = 'complianceData.allowDeposits',
	ComplianceDataAmlClassificationStatus = 'complianceData.amlClassificationStatus',
	ComplianceDataAmlCustomerQuestionnaireName = 'complianceData.amlCustomerQuestionnaire.name',
	ComplianceDataAmlCustomerQuestionnaireQuestionnaireId = 'complianceData.amlCustomerQuestionnaire.questionnaireId',
	ComplianceDataAmlCustomerQuestionnaireScore = 'complianceData.amlCustomerQuestionnaire.score',
	ComplianceDataAmlCustomerQuestionnaireScoreCategory = 'complianceData.amlCustomerQuestionnaire.scoreCategory',
	ComplianceDataClientClassification = 'complianceData.clientClassification',
	ComplianceDataComment = 'complianceData.comment',
	ComplianceDataComplianceApprovedDate = 'complianceData.complianceApprovedDate',
	ComplianceDataComplianceStage = 'complianceData.complianceStage',
	ComplianceDataComplianceStage$list = 'complianceData.complianceStage$list',
	ComplianceDataComplianceSuspendedGround = 'complianceData.complianceSuspendedGround',
	ComplianceDataComplianceSuspensionDate = 'complianceData.complianceSuspensionDate',
	ComplianceDataCustomerECDDPhone = 'complianceData.customerECDDPhone',
	ComplianceDataCustomerQuestionnaireFullyRegistered = 'complianceData.customerQuestionnaire.fullyRegistered',
	ComplianceDataCustomerQuestionnaireName = 'complianceData.customerQuestionnaire.name',
	ComplianceDataCustomerQuestionnaireQuestionnaireId = 'complianceData.customerQuestionnaire.questionnaireId',
	ComplianceDataCustomerQuestionnaireScore = 'complianceData.customerQuestionnaire.score',
	ComplianceDataCustomerQuestionnaireScoreCategoryScoreLevel = 'complianceData.customerQuestionnaire.scoreCategory.scoreLevel',
	ComplianceDataEcddOptions = 'complianceData.ecddOptions',
	ComplianceDataEcddPerformed = 'complianceData.ecddPerformed',
	ComplianceDataEvAgreement = 'complianceData.evAgreement',
	ComplianceDataEvAgreementDate = 'complianceData.evAgreementDate',
	ComplianceDataFatca = 'complianceData.fatca',
	ComplianceDataFirstDepositCountry = 'complianceData.firstDepositCountry',
	ComplianceDataFirstDepositCountry$payload = 'complianceData.firstDepositCountry$payload',
	ComplianceDataFirstEyeApproved = 'complianceData.firstEyeApproved',
	ComplianceDataFirstEyeComplianceApprover = 'complianceData.firstEyeComplianceApprover',
	ComplianceDataFullRegistrationBonusTermsAndConditionsAccepted = 'complianceData.fullRegistrationBonusTermsAndConditionsAccepted',
	ComplianceDataFullRegistrationIp = 'complianceData.fullRegistrationIp',
	ComplianceDataGbgApproved = 'complianceData.gbgApproved',
	ComplianceDataGbgApprovedDate = 'complianceData.gbgApprovedDate',
	ComplianceDataGbgApprovedStatus = 'complianceData.gbgApprovedStatus',
	ComplianceDataGbgAuthenticationId = 'complianceData.gbgAuthenticationId',
	ComplianceDataGracePeriodDuration = 'complianceData.gracePeriodDuration',
	ComplianceDataGracePeriodEligible = 'complianceData.gracePeriodEligible',
	ComplianceDataGracePeriodStatus = 'complianceData.gracePeriodStatus',
	ComplianceDataHasLivenessTest = 'complianceData.hasLivenessTest',
	ComplianceDataHasProofOfId = 'complianceData.hasProofOfId',
	ComplianceDataHasProofOfResidence = 'complianceData.hasProofOfResidence',
	ComplianceDataLowScoreCautionAcceptedDate = 'complianceData.lowScoreCautionAcceptedDate',
	ComplianceDataLowScoreWarningAccepted = 'complianceData.lowScoreWarningAccepted',
	ComplianceDataMediumScoreCautionAccepted = 'complianceData.mediumScoreCautionAccepted',
	ComplianceDataMediumScoreCautionAcceptedDate = 'complianceData.mediumScoreCautionAcceptedDate',
	ComplianceDataNci = 'complianceData.nci',
	ComplianceDataNciStatus = 'complianceData.nciStatus',
	ComplianceDataNewTradingAccountForbidden = 'complianceData.newTradingAccountForbidden',
	ComplianceDataPendingComplianceGround = 'complianceData.pendingComplianceGround',
	ComplianceDataPersonalInformationConfirmed = 'complianceData.personalInformationConfirmed',
	ComplianceDataPersonalInformationConfirmedDate = 'complianceData.personalInformationConfirmedDate',
	ComplianceDataPoiExpirationDate = 'complianceData.poiExpirationDate',
	ComplianceDataPoliticallyExposedPerson = 'complianceData.politicallyExposedPerson',
	ComplianceDataPorExpirationDate = 'complianceData.porExpirationDate',
	ComplianceDataQuantranksConsent = 'complianceData.quantranksConsent',
	ComplianceDataQuantranksConsentDate = 'complianceData.quantranksConsentDate',
	ComplianceDataReAssessment = 'complianceData.reAssessment',
	ComplianceDataReAssessmentDate = 'complianceData.reAssessmentDate',
	ComplianceDataRiskAccepted = 'complianceData.riskAccepted',
	ComplianceDataRiskAcceptedDate = 'complianceData.riskAcceptedDate',
	ComplianceDataSharedealingConsent = 'complianceData.sharedealingConsent',
	ComplianceDataSharedealingConsentDate = 'complianceData.sharedealingConsentDate',
	ComplianceDataTaxJurisdiction = 'complianceData.taxJurisdiction',
	ComplianceDataTaxJurisdiction2 = 'complianceData.taxJurisdiction2',
	ComplianceDataTermsAndConditionsAccepted = 'complianceData.termsAndConditionsAccepted',
	ComplianceDataTermsAndConditionsAcceptedDate = 'complianceData.termsAndConditionsAcceptedDate',
	ComplianceDataTermsConditionsNewVersion = 'complianceData.termsConditionsNewVersion',
	ComplianceDataTermsConditionsNewVersionTime = 'complianceData.termsConditionsNewVersionTime',
	ComplianceDataTin = 'complianceData.tin',
	ComplianceDataTin2 = 'complianceData.tin2',
	ComplianceDataTinAbsenceReason = 'complianceData.tinAbsenceReason',
	ComplianceDataW8Form = 'complianceData.w8Form',
	ComplianceDataWhyCannotObtainTIN = 'complianceData.whyCannotObtainTIN',
	ComplianceDataWorldCheckFulfilled = 'complianceData.worldCheckFulfilled',
	CreationTime = 'creationTime',
	CustomerAccountType = 'customerAccountType',
	CustomerConcat = 'customerConcat',
	CustomerEntityType = 'customerEntityType',
	CustomerFinancesLastActivityDate = 'customerFinances.lastActivityDate',
	CustomerFinancesTotalCancelledDepositsAmount = 'customerFinances.totalCancelledDepositsAmount',
	CustomerFinancesTotalCancelledDepositsCount = 'customerFinances.totalCancelledDepositsCount',
	CustomerFinancesTotalDoneDepositsAmount = 'customerFinances.totalDoneDepositsAmount',
	CustomerFinancesTotalDoneDepositsCount = 'customerFinances.totalDoneDepositsCount',
	CustomerFinancesTotalFailedDepositsAmount = 'customerFinances.totalFailedDepositsAmount',
	CustomerFinancesTotalFailedDepositsCount = 'customerFinances.totalFailedDepositsCount',
	CustomerFinancesTotalPendingDepositsAmount = 'customerFinances.totalPendingDepositsAmount',
	CustomerFinancesTotalPendingDepositsCount = 'customerFinances.totalPendingDepositsCount',
	CustomerLoginInfoPasswordCreationTime = 'customerLoginInfo.passwordCreationTime',
	CustomerStateEngagementState = 'customerState.engagementState',
	CustomerStateModificationTime = 'customerState.modificationTime',
	CustomerStateNonEngagedType = 'customerState.nonEngagedType',
	DatePOA = 'datePOA',
	DealingRisk = 'dealingRisk',
	Description = 'description',
	DisqualificationReason$list = 'disqualificationReason$list',
	DisqualificationReason$value = 'disqualificationReason$value',
	FinancialRisk = 'financialRisk',
	FirstRegistrationCountry = 'firstRegistrationCountry',
	FullRegistration = 'fullRegistration',
	Id = 'id',
	InteractionLastLoginCountry = 'interaction.lastLoginCountry',
	InteractionLastSource = 'interaction.lastSource',
	InteractionLoginIp = 'interaction.loginIp',
	InteractionModificationTime = 'interaction.modificationTime',
	Ip = 'ip',
	JointAccountReason = 'jointAccountReason',
	JointPrimaryOwner = 'jointPrimaryOwner',
	LastRegistrationTime = 'lastRegistrationTime',
	LastWorldCheckIdIfMatched = 'lastWorldCheckIdIfMatched',
	LeverageLevels = 'leverageLevels',
	LeverageTypeNames = 'leverageTypeNames',
	LoginName = 'loginName',
	Manager = 'manager',
	ModificationTime = 'modificationTime',
	ModifiedBy = 'modifiedBy',
	Npi = 'npi',
	NpiType = 'npiType',
	NumberOfDeposits = 'numberOfDeposits',
	NumberOfWithdrawals = 'numberOfWithdrawals',
	OneClickClosingAccountStatus = 'oneClickClosingAccountStatus',
	OneClickClosingAccountStatusGround = 'oneClickClosingAccountStatusGround',
	OneClickClosingAccountStatusModificationTime = 'oneClickClosingAccountStatusModificationTime',
	Owner = 'owner',
	ParentCustomerId = 'parentCustomerId',
	PartnerCompany = 'partnerCompany',
	PartnerCompany$date = 'partnerCompany$date',
	PartnerCompany$list = 'partnerCompany$list',
	PartnerCompanyName = 'partnerCompany.name',
	Password = 'password',
	PendingBonusAmount = 'pendingBonus.amount',
	PendingBonusAmountUSD = 'pendingBonus.amountUSD',
	PendingBonusCurrentPointsAmount = 'pendingBonus.currentPointsAmount',
	PendingBonusExpirationDate = 'pendingBonus.expirationDate',
	PendingBonusStatus = 'pendingBonus.status',
	PendingBonusTargetAmountOfPoints = 'pendingBonus.targetAmountOfPoints',
	PendingBonusTradingAccountId = 'pendingBonus.tradingAccountId',
	PersonAddressAddress = 'person.address.address',
	PersonAddressAddress2 = 'person.address.address2',
	PersonAddressCity = 'person.address.city',
	PersonAddressZipCode = 'person.address.zipCode',
	PersonAgeGroup = 'person.ageGroup',
	PersonBirthDate = 'person.birthDate',
	PersonCitizenship = 'person.citizenship',
	PersonCountry = 'person.country',
	PersonCountry$list = 'person.country$list',
	PersonCountry$payload = 'person.country$payload',
	PersonDriverLicense = 'person.driverLicense',
	PersonEmail1EmailAddress = 'person.email1.emailAddress',
	PersonEmail1Verified = 'person.email1.verified',
	PersonEmail2EmailAddress = 'person.email2.emailAddress',
	PersonEmail2Verified = 'person.email2.verified',
	PersonFirstName = 'person.firstName',
	PersonFirstNameEnglish = 'person.firstNameEnglish',
	PersonGender = 'person.gender',
	PersonIdNumber = 'person.idNumber',
	PersonLanguage = 'person.language',
	PersonLanguageDbValue = 'person.language.dbValue',
	PersonLastName = 'person.lastName',
	PersonLastNameEnglish = 'person.lastNameEnglish',
	PersonLei = 'person.lei',
	PersonLeiExpirationDate = 'person.leiExpirationDate',
	PersonNameEnglish = 'person.nameEnglish',
	PersonNationality = 'person.nationality',
	PersonPassport = 'person.passport',
	PersonPhone1CountryCode = 'person.phone1.countryCode',
	PersonPhone1Num = 'person.phone1.num',
	PersonPhone1Verified = 'person.phone1.verified',
	PersonPhone2CountryCode = 'person.phone2.countryCode',
	PersonPhone2Num = 'person.phone2.num',
	PersonPhone2Verified = 'person.phone2.verified',
	PersonPhone4Num = 'person.phone4.num',
	PoiExpirationDays = 'poiExpirationDays',
	PorExpirationDays = 'porExpirationDays',
	RealTradingAccountCount = 'realTradingAccountCount',
	RegistrationCompanySelection = 'registration.companySelection',
	RegistrationMarketingParamsCampaign = 'registration.marketingParams.campaign',
	RegistrationMarketingParamsReferrer = 'registration.marketingParams.referrer',
	RegistrationTrafficSourceAffiliateId = 'registration.trafficSource.affiliateId',
	RegistrationTrafficSourceAffiliateId$affiliateRemark = 'registration.trafficSource.affiliateId$affiliateRemark',
	RegistrationTrafficSourceLandingPage = 'registration.trafficSource.landingPage',
	RegistrationTrafficSourceMedia = 'registration.trafficSource.media',
	RegistrationTrafficSourceNetwork = 'registration.trafficSource.network',
	RegistrationTrafficSourcePromotionName = 'registration.trafficSource.promotionName',
	RegistrationTrafficSourceTrafficId = 'registration.trafficSource.trafficId',
	RegistrationTrafficSourceZone = 'registration.trafficSource.zone',
	RegistrationStatus = 'registrationStatus',
	RegistrationsCount = 'registrationsCount',
	RegulationTypeName = 'regulationType.name',
	SecurityAnswer = 'securityAnswer',
	SecurityQuestion = 'securityQuestion',
	TotalDeposits = 'totalDeposits',
	TotalWithdrawals = 'totalWithdrawals',
	TradingTotalsRealEquity = 'tradingTotals.realEquity'
}

export type ClientPropAssignedPoolName = {
	[ClientProp.AssignedPoolName] : string | null
}
export type ClientPropAssignedUser = {
	[ClientProp.AssignedUser] : models.UserDto
}
export type ClientPropAvailableProducts = {
	[ClientProp.AvailableProducts] : models.CollectionValueDto<number, never>[]
}
export type ClientPropBlacklisted = {
	[ClientProp.Blacklisted] : boolean | null
}
export type ClientPropBrandName = {
	[ClientProp.BrandName] : string | null
}
export type ClientPropCompanyRegulationCountryCompanyRegulationGracePeriodScoreLevels = {
	[ClientProp.CompanyRegulationCountryCompanyRegulationGracePeriodScoreLevels] : models.AScoreLevel[] | null
}
export type ClientPropComplianceDataAllowDeposits = {
	[ClientProp.ComplianceDataAllowDeposits] : boolean | null
}
export type ClientPropComplianceDataAmlClassificationStatus = {
	[ClientProp.ComplianceDataAmlClassificationStatus] : 'LOW' | 'MEDIUM' | 'HIGH_LOW' | 'HIGH_MEDIUM' | 'HIGH_HIGH' | null
}
export type ClientPropComplianceDataAmlCustomerQuestionnaireName = {
	[ClientProp.ComplianceDataAmlCustomerQuestionnaireName] : string | null
}
export type ClientPropComplianceDataAmlCustomerQuestionnaireQuestionnaireId = {
	[ClientProp.ComplianceDataAmlCustomerQuestionnaireQuestionnaireId] : number | null
}
export type ClientPropComplianceDataAmlCustomerQuestionnaireScore = {
	[ClientProp.ComplianceDataAmlCustomerQuestionnaireScore] : number | null
}
export type ClientPropComplianceDataAmlCustomerQuestionnaireScoreCategory = {
	[ClientProp.ComplianceDataAmlCustomerQuestionnaireScoreCategory] : models.QuestionnaireScoreCategoryDto | null
}
export type ClientPropComplianceDataClientClassification = {
	[ClientProp.ComplianceDataClientClassification] : 'RETAIL' | 'ELECTIVE_PROFESSIONAL' | 'PROFESSIONAL' | 'ELIGIBLE_COUNTER_PARTY' | 'TECH_WHITELABEL' | null
}
export type ClientPropComplianceDataComment = {
	[ClientProp.ComplianceDataComment] : string | null
}
export type ClientPropComplianceDataComplianceApprovedDate = {
	[ClientProp.ComplianceDataComplianceApprovedDate] : number | null
}
export type ClientPropComplianceDataComplianceStage = {
	[ClientProp.ComplianceDataComplianceStage] : 'NON_COMPLIANT' | 'COMPLIANT' | 'PENDING_COMPLIANCE' | 'LIMITED_COMPLIED' | 'COMPLIANCE_REVOKED' | 'COMPLIANCE_SUSPENDED' | null
}
export type ClientPropComplianceDataComplianceStage$list = {
	[ClientProp.ComplianceDataComplianceStage$list] : models.CollectionValueDto<number, never>[]
}
export type ClientPropComplianceDataComplianceSuspendedGround = {
	[ClientProp.ComplianceDataComplianceSuspendedGround] : 'INACTIVITY' | 'INCOMPLETE_ECONOMIC_PROFILE' | 'EXPIRED_DOCUMENTATION' | 'INSUFFICIENT_FUNDS_SOURCE_INFORMATION' | 'INCOMPLETE_ECDD' | 'VULNERABLE_CLIENT_CONSUMER_DUTY' | 'SELF_EXCLUSION_REQUEST_CONSUMER_DUTY' | null
}
export type ClientPropComplianceDataComplianceSuspensionDate = {
	[ClientProp.ComplianceDataComplianceSuspensionDate] : number | null
}
export type ClientPropComplianceDataCustomerECDDPhone = {
	[ClientProp.ComplianceDataCustomerECDDPhone] : 'NOT_RELEVANT' | 'PHONE1' | 'PHONE2' | null
}
export type ClientPropComplianceDataCustomerQuestionnaireFullyRegistered = {
	[ClientProp.ComplianceDataCustomerQuestionnaireFullyRegistered] : boolean | null
}
export type ClientPropComplianceDataCustomerQuestionnaireName = {
	[ClientProp.ComplianceDataCustomerQuestionnaireName] : string | null
}
export type ClientPropComplianceDataCustomerQuestionnaireQuestionnaireId = {
	[ClientProp.ComplianceDataCustomerQuestionnaireQuestionnaireId] : number | null
}
export type ClientPropComplianceDataCustomerQuestionnaireScore = {
	[ClientProp.ComplianceDataCustomerQuestionnaireScore] : number | null
}
export type ClientPropComplianceDataCustomerQuestionnaireScoreCategoryScoreLevel = {
	[ClientProp.ComplianceDataCustomerQuestionnaireScoreCategoryScoreLevel] : 'LOW' | 'MEDIUM' | 'HIGH' | null
}
export type ClientPropComplianceDataEcddOptions = {
	[ClientProp.ComplianceDataEcddOptions] : ('FIRST_DEPOSIT_FROM_EEA_OR_EQUIVALENT' | 'PHONE_VERIFICATION' | 'REGISTERED_POST' | 'CONFIRMATION_LETTER' | 'VIDEO_CALL' | 'ELECTRONIC_VERIFICATION')[] | null
}
export type ClientPropComplianceDataEcddPerformed = {
	[ClientProp.ComplianceDataEcddPerformed] : boolean | null
}
export type ClientPropComplianceDataEvAgreement = {
	[ClientProp.ComplianceDataEvAgreement] : boolean | null
}
export type ClientPropComplianceDataEvAgreementDate = {
	[ClientProp.ComplianceDataEvAgreementDate] : number | null
}
export type ClientPropComplianceDataFatca = {
	[ClientProp.ComplianceDataFatca] : 'YES' | 'NO' | null
}
export type ClientPropComplianceDataFirstDepositCountry = {
	[ClientProp.ComplianceDataFirstDepositCountry] : 'NA' | 'AFGHANISTAN' | 'ÅLAND_ISLANDS' | 'ALBANIA' | 'ALGERIA' | 'AMERICAN_SAMOA' | 'ANDORRA' | 'ANGOLA' | 'ANGUILLA' | 'ANTARCTICA' | 'ANTIGUA_AND_BARBUDA' | 'ARGENTINA' | 'ARMENIA' | 'ARUBA' | 'AUSTRALIA' | 'AUSTRIA' | 'AZERBAIJAN' | 'BAHAMAS' | 'BAHRAIN' | 'BANGLADESH' | 'BARBADOS' | 'BELARUS' | 'BELGIUM' | 'BELIZE' | 'BENIN' | 'BERMUDA' | 'BHUTAN' | 'BOLIVIA' | 'BONAIRE_SINT_EUSTATIUS_AND_SABA' | 'BOSNIA_AND_HERZEGOVINA' | 'BOTSWANA' | 'BOUVET_ISLAND' | 'BRAZIL' | 'BRITISH_INDIAN_OCEAN_TERRITORY' | 'BRUNEI_DARUSSALAM' | 'BULGARIA' | 'BURKINA_FASO' | 'BURUNDI' | 'CAMBODIA' | 'CAMEROON' | 'CANADA' | 'CAPE_VERDE' | 'CAYMAN_ISLANDS' | 'CENTRAL_AFRICAN_REPUBLIC' | 'CHAD' | 'CHILE' | 'CHINA' | 'CHRISTMAS_ISLAND' | 'COCOS_ISLANDS' | 'COLOMBIA' | 'COMOROS' | 'CONGO' | 'CONGO_THE_DEMOCRATIC_REPUBLIC_OF_THE' | 'COOK_ISLANDS' | 'COSTA_RICA' | 'CROATIA' | 'CUBA' | 'CURAÇAO' | 'CYPRUS' | 'CZECH_REPUBLIC' | 'CÔTE_DIVOIRE' | 'DENMARK' | 'DJIBOUTI' | 'DOMINICA' | 'DOMINICAN_REPUBLIC' | 'EAST_TIMOR' | 'ECUADOR' | 'EGYPT' | 'EL_SALVADOR' | 'EQUATORIAL_GUINEA' | 'ERITREA' | 'ESTONIA' | 'ETHIOPIA' | 'FALKLAND_ISLANDS' | 'FAROE_ISLANDS' | 'FIJI' | 'FINLAND' | 'FRANCE' | 'FRENCH_GUIANA' | 'FRENCH_POLYNESIA' | 'FRENCH_SOUTHERN_TERRITORIES' | 'GABON' | 'GAMBIA' | 'Georgia' | 'GERMANY' | 'GHANA' | 'GIBRALTAR' | 'GREECE' | 'GREENLAND' | 'GRENADA' | 'GUADELOUPE' | 'GUAM' | 'GUATEMALA' | 'GUERNSEY' | 'GUINEA' | 'GUINEA_BISSAU' | 'GUYANA' | 'HAITI' | 'HEARD_ISLAND_AND_MCDONALD_ISLANDS' | 'HONDURAS' | 'HONG_KONG' | 'Hungary' | 'ICELAND' | 'INDIA' | 'INDONESIA' | 'IRAN' | 'IRAQ' | 'IRELAND' | 'ISLE_OF_MAN' | 'ISRAEL' | 'ITALY' | 'JAMAICA' | 'JAPAN' | 'JERSEY' | 'JORDAN' | 'KAZAKHSTAN' | 'KENYA' | 'KIRIBATI' | 'KOSOVO' | 'KOREA_DEMOCRATIC_PEOPLE_REPUBLIC_OF' | 'KOREA_REPUBLIC_OF' | 'KUWAIT' | 'KYRGYZSTAN' | 'LAO_PEOPLE_DEMOCRATIC_REPUBLIC' | 'LATVIA' | 'LEBANON' | 'LESOTHO' | 'LIBERIA' | 'LIBYAN' | 'LIECHTENSTEIN' | 'LITHUANIA' | 'LUXEMBOURG' | 'MACAO' | 'MADAGASCAR' | 'MALAWI' | 'MALAYSIA' | 'MALDIVES' | 'MALI' | 'MALTA' | 'MARSHALL_ISLANDS' | 'MARTINIQUE' | 'MAURITANIA' | 'MAURITIUS' | 'MAYOTTE' | 'MEXICO' | 'MICRONESIA' | 'MOLDOVA_REPUBLIC_OF' | 'MONACO' | 'MONGOLIA' | 'MONTENEGRO' | 'MONTSERRAT' | 'MOROCCO' | 'MOZAMBIQUE' | 'MYANMAR' | 'NAMIBIA' | 'NAURU' | 'NEPAL' | 'NETHERLANDS' | 'NETHERLANDS_ANTILLES' | 'NEW_CALEDONIA' | 'NEW_ZEALAND' | 'NICARAGUA' | 'NIGER' | 'NIGERIA' | 'NIUE' | 'NORFOLK_ISLAND' | 'NORTHERN_MARIANA_ISLANDS' | 'NORWAY' | 'OMAN' | 'PAKISTAN' | 'PALAU' | 'PALESTINIAN_TERRITORY_OCCUPIED' | 'PANAMA' | 'PAPUA_NEW_GUINEA' | 'PARAGUAY' | 'PERU' | 'PHILIPPINES' | 'PITCAIRN' | 'POLAND' | 'PORTUGAL' | 'PUERTO_RICO' | 'QATAR' | 'ROMANIA' | 'RUSSIAN_FEDERATION' | 'RWANDA' | 'RÉUNION' | 'SAINT_BARTHÉLEMY_BL' | 'SAINT_HELENA' | 'SAINT_KITTS_AND_NEVIS' | 'SAINT_LUCIA' | 'SAINT_MARTIN_FRENCH_PART' | 'SAINT_PIERRE_AND_MIQUELON' | 'SAINT_VINCENT_AND_THE_GRENADINES' | 'SAMOA' | 'SAN_MARINO' | 'SAO_TOME_AND_PRINCIPE' | 'SAUDI_ARABIA' | 'SENEGAL' | 'SERBIA' | 'SEYCHELLES' | 'SIERRA_LEONE' | 'SINGAPORE' | 'SINT_MAARTEN_DUTCH_PART' | 'SLOVAKIA' | 'SLOVENIA' | 'SOLOMON_ISLANDS' | 'SOMALIA' | 'SOUTH_AFRICA' | 'SOUTH_GEORGIA_AND_THE_SOUTH_SANDWICH_ISLANDS' | 'SOUTH_SUDAN' | 'SPAIN' | 'SRI_LANKA' | 'SUDAN' | 'SURINAME' | 'SVALBARD_AND_JAN_MAYEN' | 'SWAZILAND' | 'SWEDEN' | 'SWITZERLAND' | 'SYRIAN_ARAB_REPUBLIC' | 'TAIWAN' | 'TAJIKISTAN' | 'THAILAND' | 'THE_FORMER_YUGOSLAV_REPUBLIC_OF_MACEDONIA' | 'TOGO' | 'TOKELAU' | 'TONGA' | 'TRINIDAD_AND_TOBAGO' | 'TUNISIA' | 'TURKEY' | 'TURKMENISTAN' | 'TURKS_AND_CAICOS_ISLANDS' | 'TUVALU' | 'UGANDA' | 'UKRAINE' | 'UNITED_ARAB_EMIRATES' | 'UNITED_KINGDOM' | 'UNITED_REPUBLIC_OF_TANZANIA' | 'UNITED_STATES_MINOR_OUTLYING_ISLANDS' | 'URUGUAY' | 'USA' | 'UZBEKISTAN' | 'VANUATU' | 'VATICAN_CITY_STATE' | 'VENEZUELA' | 'VIET_NAM' | 'VIRGIN_ISLANDS_GB' | 'VIRGIN_ISLANDS_USA' | 'WALLIS_AND_FUTUNA' | 'WESTERN_SAHARA' | 'YEMEN' | 'ZAMBIA' | 'ZIMBABWE' | null
}
export type ClientPropComplianceDataFirstDepositCountry$payload = {
	[ClientProp.ComplianceDataFirstDepositCountry$payload] : models.CountryPayloadDto | null
}
export type ClientPropComplianceDataFirstEyeApproved = {
	[ClientProp.ComplianceDataFirstEyeApproved] : boolean | null
}
export type ClientPropComplianceDataFirstEyeComplianceApprover = {
	[ClientProp.ComplianceDataFirstEyeComplianceApprover] : models.UserDto
}
export type ClientPropComplianceDataFullRegistrationBonusTermsAndConditionsAccepted = {
	[ClientProp.ComplianceDataFullRegistrationBonusTermsAndConditionsAccepted] : boolean | null
}
export type ClientPropComplianceDataFullRegistrationIp = {
	[ClientProp.ComplianceDataFullRegistrationIp] : string | null
}
export type ClientPropComplianceDataGbgApproved = {
	[ClientProp.ComplianceDataGbgApproved] : 'UN_CHECKED' | 'PASSED' | 'REFER' | 'ALERT' | null
}
export type ClientPropComplianceDataGbgApprovedDate = {
	[ClientProp.ComplianceDataGbgApprovedDate] : number | null
}
export type ClientPropComplianceDataGbgApprovedStatus = {
	[ClientProp.ComplianceDataGbgApprovedStatus] : boolean | null
}
export type ClientPropComplianceDataGbgAuthenticationId = {
	[ClientProp.ComplianceDataGbgAuthenticationId] : string | null
}
export type ClientPropComplianceDataGracePeriodDuration = {
	[ClientProp.ComplianceDataGracePeriodDuration] : number | null
}
export type ClientPropComplianceDataGracePeriodEligible = {
	[ClientProp.ComplianceDataGracePeriodEligible] : boolean | null
}
export type ClientPropComplianceDataGracePeriodStatus = {
	[ClientProp.ComplianceDataGracePeriodStatus] : 'GP_NONE' | 'GP_ENTERED' | 'GP_REMINDER_SENT' | 'GP_TASK_CREATED' | 'GP_EXIT_SUCCESS' | 'GP_EXIT_UNSUCCESSFUL' | null
}
export type ClientPropComplianceDataHasLivenessTest = {
	[ClientProp.ComplianceDataHasLivenessTest] : boolean | null
}
export type ClientPropComplianceDataHasProofOfId = {
	[ClientProp.ComplianceDataHasProofOfId] : boolean | null
}
export type ClientPropComplianceDataHasProofOfResidence = {
	[ClientProp.ComplianceDataHasProofOfResidence] : boolean | null
}
export type ClientPropComplianceDataLowScoreCautionAcceptedDate = {
	[ClientProp.ComplianceDataLowScoreCautionAcceptedDate] : number | null
}
export type ClientPropComplianceDataLowScoreWarningAccepted = {
	[ClientProp.ComplianceDataLowScoreWarningAccepted] : boolean | null
}
export type ClientPropComplianceDataMediumScoreCautionAccepted = {
	[ClientProp.ComplianceDataMediumScoreCautionAccepted] : boolean | null
}
export type ClientPropComplianceDataMediumScoreCautionAcceptedDate = {
	[ClientProp.ComplianceDataMediumScoreCautionAcceptedDate] : number | null
}
export type ClientPropComplianceDataNci = {
	[ClientProp.ComplianceDataNci] : string | null
}
export type ClientPropComplianceDataNciStatus = {
	[ClientProp.ComplianceDataNciStatus] : 'NONE' | 'PENDING' | 'IN_PROCESS' | 'APPROVED' | 'REJECTED' | null
}
export type ClientPropComplianceDataNewTradingAccountForbidden = {
	[ClientProp.ComplianceDataNewTradingAccountForbidden] : boolean | null
}
export type ClientPropComplianceDataPendingComplianceGround = {
	[ClientProp.ComplianceDataPendingComplianceGround] : 'PENDING_ECDD' | 'PENDING_PHONE_VERIFICATION' | 'PENDING_NCI' | 'FOURTEEN_DAYS' | null
}
export type ClientPropComplianceDataPersonalInformationConfirmed = {
	[ClientProp.ComplianceDataPersonalInformationConfirmed] : boolean | null
}
export type ClientPropComplianceDataPersonalInformationConfirmedDate = {
	[ClientProp.ComplianceDataPersonalInformationConfirmedDate] : number | null
}
export type ClientPropComplianceDataPoiExpirationDate = {
	[ClientProp.ComplianceDataPoiExpirationDate] : number | null
}
export type ClientPropComplianceDataPoliticallyExposedPerson = {
	[ClientProp.ComplianceDataPoliticallyExposedPerson] : 'NOT_RELEVANT' | 'YES' | 'NO' | null
}
export type ClientPropComplianceDataPorExpirationDate = {
	[ClientProp.ComplianceDataPorExpirationDate] : number | null
}
export type ClientPropComplianceDataQuantranksConsent = {
	[ClientProp.ComplianceDataQuantranksConsent] : boolean | null
}
export type ClientPropComplianceDataQuantranksConsentDate = {
	[ClientProp.ComplianceDataQuantranksConsentDate] : number | null
}
export type ClientPropComplianceDataReAssessment = {
	[ClientProp.ComplianceDataReAssessment] : boolean | null
}
export type ClientPropComplianceDataReAssessmentDate = {
	[ClientProp.ComplianceDataReAssessmentDate] : number | null
}
export type ClientPropComplianceDataRiskAccepted = {
	[ClientProp.ComplianceDataRiskAccepted] : boolean | null
}
export type ClientPropComplianceDataRiskAcceptedDate = {
	[ClientProp.ComplianceDataRiskAcceptedDate] : number | null
}
export type ClientPropComplianceDataSharedealingConsent = {
	[ClientProp.ComplianceDataSharedealingConsent] : boolean | null
}
export type ClientPropComplianceDataSharedealingConsentDate = {
	[ClientProp.ComplianceDataSharedealingConsentDate] : number | null
}
export type ClientPropComplianceDataTaxJurisdiction = {
	[ClientProp.ComplianceDataTaxJurisdiction] : 'NOT_RELEVANT' | 'NO_JURISDICTION' | 'AFGHANISTAN' | 'ÅLAND_ISLANDS' | 'ALBANIA' | 'ALGERIA' | 'AMERICAN_SAMOA' | 'ANDORRA' | 'ANGOLA' | 'ANGUILLA' | 'ANTARCTICA' | 'ANTIGUA_AND_BARBUDA' | 'ARGENTINA' | 'ARMENIA' | 'ARUBA' | 'AUSTRALIA' | 'AUSTRIA' | 'AZERBAIJAN' | 'BAHAMAS' | 'BAHRAIN' | 'BANGLADESH' | 'BARBADOS' | 'BELARUS' | 'BELGIUM' | 'BELIZE' | 'BENIN' | 'BERMUDA' | 'BHUTAN' | 'BOLIVIA' | 'BONAIRE_SINT_EUSTATIUS_AND_SABA' | 'BOSNIA_AND_HERZEGOVINA' | 'BOTSWANA' | 'BOUVET_ISLAND' | 'BRAZIL' | 'BRITISH_INDIAN_OCEAN_TERRITORY' | 'BRUNEI_DARUSSALAM' | 'BULGARIA' | 'BURKINA_FASO' | 'BURUNDI' | 'CAMBODIA' | 'CAMEROON' | 'CANADA' | 'CAPE_VERDE' | 'CAYMAN_ISLANDS' | 'CENTRAL_AFRICAN_REPUBLIC' | 'CHAD' | 'CHILE' | 'CHINA' | 'CHRISTMAS_ISLAND' | 'COCOS_ISLANDS' | 'COLOMBIA' | 'COMOROS' | 'CONGO' | 'CONGO_THE_DEMOCRATIC_REPUBLIC_OF_THE' | 'COOK_ISLANDS' | 'COSTA_RICA' | 'CROATIA' | 'CUBA' | 'CURAÇAO' | 'CYPRUS' | 'CZECH_REPUBLIC' | 'CÔTE_DIVOIRE' | 'DENMARK' | 'DJIBOUTI' | 'DOMINICA' | 'DOMINICAN_REPUBLIC' | 'EAST_TIMOR' | 'ECUADOR' | 'EGYPT' | 'EL_SALVADOR' | 'EQUATORIAL_GUINEA' | 'ERITREA' | 'ESTONIA' | 'ETHIOPIA' | 'FALKLAND_ISLANDS' | 'FAROE_ISLANDS' | 'FIJI' | 'FINLAND' | 'FRANCE' | 'FRENCH_GUIANA' | 'FRENCH_POLYNESIA' | 'FRENCH_SOUTHERN_TERRITORIES' | 'GABON' | 'GAMBIA' | 'Georgia' | 'GERMANY' | 'GHANA' | 'GIBRALTAR' | 'GREECE' | 'GREENLAND' | 'GRENADA' | 'GUADELOUPE' | 'GUAM' | 'GUATEMALA' | 'GUERNSEY' | 'GUINEA' | 'GUINEA_BISSAU' | 'GUYANA' | 'HAITI' | 'HEARD_ISLAND_AND_MCDONALD_ISLANDS' | 'HONDURAS' | 'HONG_KONG' | 'Hungary' | 'ICELAND' | 'INDIA' | 'INDONESIA' | 'IRAN' | 'IRAQ' | 'IRELAND' | 'ISLE_OF_MAN' | 'ISRAEL' | 'ITALY' | 'JAMAICA' | 'JAPAN' | 'JERSEY' | 'JORDAN' | 'KAZAKHSTAN' | 'KENYA' | 'KIRIBATI' | 'KOREA_DEMOCRATIC_PEOPLE_REPUBLIC_OF' | 'KOREA_REPUBLIC_OF' | 'KOSOVO' | 'KUWAIT' | 'KYRGYZSTAN' | 'LAO_PEOPLE_DEMOCRATIC_REPUBLIC' | 'LATVIA' | 'LEBANON' | 'LESOTHO' | 'LIBERIA' | 'LIBYAN' | 'LIECHTENSTEIN' | 'LITHUANIA' | 'LUXEMBOURG' | 'MACAO' | 'MADAGASCAR' | 'MALAWI' | 'MALAYSIA' | 'MALDIVES' | 'MALI' | 'MALTA' | 'MARSHALL_ISLANDS' | 'MARTINIQUE' | 'MAURITANIA' | 'MAURITIUS' | 'MAYOTTE' | 'MEXICO' | 'MICRONESIA' | 'MOLDOVA_REPUBLIC_OF' | 'MONACO' | 'MONGOLIA' | 'MONTENEGRO' | 'MONTSERRAT' | 'MOROCCO' | 'MOZAMBIQUE' | 'MYANMAR' | 'NAMIBIA' | 'NAURU' | 'NEPAL' | 'NETHERLANDS' | 'NETHERLANDS_ANTILLES' | 'NEW_CALEDONIA' | 'NEW_ZEALAND' | 'NICARAGUA' | 'NIGER' | 'NIGERIA' | 'NIUE' | 'NORFOLK_ISLAND' | 'NORTHERN_MARIANA_ISLANDS' | 'NORWAY' | 'OMAN' | 'PAKISTAN' | 'PALAU' | 'PALESTINIAN_TERRITORY_OCCUPIED' | 'PANAMA' | 'PAPUA_NEW_GUINEA' | 'PARAGUAY' | 'PERU' | 'PHILIPPINES' | 'PITCAIRN' | 'POLAND' | 'PORTUGAL' | 'PUERTO_RICO' | 'QATAR' | 'ROMANIA' | 'RUSSIAN_FEDERATION' | 'RWANDA' | 'RÉUNION' | 'SAINT_BARTHÉLEMY_BL' | 'SAINT_HELENA' | 'SAINT_KITTS_AND_NEVIS' | 'SAINT_LUCIA' | 'SAINT_MARTIN_FRENCH_PART' | 'SAINT_PIERRE_AND_MIQUELON' | 'SAINT_VINCENT_AND_THE_GRENADINES' | 'SAMOA' | 'SAN_MARINO' | 'SAO_TOME_AND_PRINCIPE' | 'SAUDI_ARABIA' | 'SENEGAL' | 'SERBIA' | 'SEYCHELLES' | 'SIERRA_LEONE' | 'SINGAPORE' | 'SINT_MAARTEN_DUTCH_PART' | 'SLOVAKIA' | 'SLOVENIA' | 'SOLOMON_ISLANDS' | 'SOMALIA' | 'SOUTH_AFRICA' | 'SOUTH_GEORGIA_AND_THE_SOUTH_SANDWICH_ISLANDS' | 'SOUTH_SUDAN' | 'SPAIN' | 'SRI_LANKA' | 'SUDAN' | 'SURINAME' | 'SVALBARD_AND_JAN_MAYEN' | 'SWAZILAND' | 'SWEDEN' | 'SWITZERLAND' | 'SYRIAN_ARAB_REPUBLIC' | 'TAIWAN' | 'TAJIKISTAN' | 'THAILAND' | 'THE_FORMER_YUGOSLAV_REPUBLIC_OF_MACEDONIA' | 'TOGO' | 'TOKELAU' | 'TONGA' | 'TRINIDAD_AND_TOBAGO' | 'TUNISIA' | 'TURKEY' | 'TURKMENISTAN' | 'TURKS_AND_CAICOS_ISLANDS' | 'TUVALU' | 'UGANDA' | 'UKRAINE' | 'UNITED_ARAB_EMIRATES' | 'UNITED_KINGDOM' | 'UNITED_REPUBLIC_OF_TANZANIA' | 'UNITED_STATES_MINOR_OUTLYING_ISLANDS' | 'URUGUAY' | 'USA' | 'UZBEKISTAN' | 'VANUATU' | 'VATICAN_CITY_STATE' | 'VENEZUELA' | 'VIET_NAM' | 'VIRGIN_ISLANDS_GB' | 'VIRGIN_ISLANDS_USA' | 'WALLIS_AND_FUTUNA' | 'WESTERN_SAHARA' | 'YEMEN' | 'ZAMBIA' | 'ZIMBABWE' | null
}
export type ClientPropComplianceDataTaxJurisdiction2 = {
	[ClientProp.ComplianceDataTaxJurisdiction2] : 'NOT_RELEVANT' | 'NO_JURISDICTION' | 'AFGHANISTAN' | 'ÅLAND_ISLANDS' | 'ALBANIA' | 'ALGERIA' | 'AMERICAN_SAMOA' | 'ANDORRA' | 'ANGOLA' | 'ANGUILLA' | 'ANTARCTICA' | 'ANTIGUA_AND_BARBUDA' | 'ARGENTINA' | 'ARMENIA' | 'ARUBA' | 'AUSTRALIA' | 'AUSTRIA' | 'AZERBAIJAN' | 'BAHAMAS' | 'BAHRAIN' | 'BANGLADESH' | 'BARBADOS' | 'BELARUS' | 'BELGIUM' | 'BELIZE' | 'BENIN' | 'BERMUDA' | 'BHUTAN' | 'BOLIVIA' | 'BONAIRE_SINT_EUSTATIUS_AND_SABA' | 'BOSNIA_AND_HERZEGOVINA' | 'BOTSWANA' | 'BOUVET_ISLAND' | 'BRAZIL' | 'BRITISH_INDIAN_OCEAN_TERRITORY' | 'BRUNEI_DARUSSALAM' | 'BULGARIA' | 'BURKINA_FASO' | 'BURUNDI' | 'CAMBODIA' | 'CAMEROON' | 'CANADA' | 'CAPE_VERDE' | 'CAYMAN_ISLANDS' | 'CENTRAL_AFRICAN_REPUBLIC' | 'CHAD' | 'CHILE' | 'CHINA' | 'CHRISTMAS_ISLAND' | 'COCOS_ISLANDS' | 'COLOMBIA' | 'COMOROS' | 'CONGO' | 'CONGO_THE_DEMOCRATIC_REPUBLIC_OF_THE' | 'COOK_ISLANDS' | 'COSTA_RICA' | 'CROATIA' | 'CUBA' | 'CURAÇAO' | 'CYPRUS' | 'CZECH_REPUBLIC' | 'CÔTE_DIVOIRE' | 'DENMARK' | 'DJIBOUTI' | 'DOMINICA' | 'DOMINICAN_REPUBLIC' | 'EAST_TIMOR' | 'ECUADOR' | 'EGYPT' | 'EL_SALVADOR' | 'EQUATORIAL_GUINEA' | 'ERITREA' | 'ESTONIA' | 'ETHIOPIA' | 'FALKLAND_ISLANDS' | 'FAROE_ISLANDS' | 'FIJI' | 'FINLAND' | 'FRANCE' | 'FRENCH_GUIANA' | 'FRENCH_POLYNESIA' | 'FRENCH_SOUTHERN_TERRITORIES' | 'GABON' | 'GAMBIA' | 'Georgia' | 'GERMANY' | 'GHANA' | 'GIBRALTAR' | 'GREECE' | 'GREENLAND' | 'GRENADA' | 'GUADELOUPE' | 'GUAM' | 'GUATEMALA' | 'GUERNSEY' | 'GUINEA' | 'GUINEA_BISSAU' | 'GUYANA' | 'HAITI' | 'HEARD_ISLAND_AND_MCDONALD_ISLANDS' | 'HONDURAS' | 'HONG_KONG' | 'Hungary' | 'ICELAND' | 'INDIA' | 'INDONESIA' | 'IRAN' | 'IRAQ' | 'IRELAND' | 'ISLE_OF_MAN' | 'ISRAEL' | 'ITALY' | 'JAMAICA' | 'JAPAN' | 'JERSEY' | 'JORDAN' | 'KAZAKHSTAN' | 'KENYA' | 'KIRIBATI' | 'KOREA_DEMOCRATIC_PEOPLE_REPUBLIC_OF' | 'KOREA_REPUBLIC_OF' | 'KOSOVO' | 'KUWAIT' | 'KYRGYZSTAN' | 'LAO_PEOPLE_DEMOCRATIC_REPUBLIC' | 'LATVIA' | 'LEBANON' | 'LESOTHO' | 'LIBERIA' | 'LIBYAN' | 'LIECHTENSTEIN' | 'LITHUANIA' | 'LUXEMBOURG' | 'MACAO' | 'MADAGASCAR' | 'MALAWI' | 'MALAYSIA' | 'MALDIVES' | 'MALI' | 'MALTA' | 'MARSHALL_ISLANDS' | 'MARTINIQUE' | 'MAURITANIA' | 'MAURITIUS' | 'MAYOTTE' | 'MEXICO' | 'MICRONESIA' | 'MOLDOVA_REPUBLIC_OF' | 'MONACO' | 'MONGOLIA' | 'MONTENEGRO' | 'MONTSERRAT' | 'MOROCCO' | 'MOZAMBIQUE' | 'MYANMAR' | 'NAMIBIA' | 'NAURU' | 'NEPAL' | 'NETHERLANDS' | 'NETHERLANDS_ANTILLES' | 'NEW_CALEDONIA' | 'NEW_ZEALAND' | 'NICARAGUA' | 'NIGER' | 'NIGERIA' | 'NIUE' | 'NORFOLK_ISLAND' | 'NORTHERN_MARIANA_ISLANDS' | 'NORWAY' | 'OMAN' | 'PAKISTAN' | 'PALAU' | 'PALESTINIAN_TERRITORY_OCCUPIED' | 'PANAMA' | 'PAPUA_NEW_GUINEA' | 'PARAGUAY' | 'PERU' | 'PHILIPPINES' | 'PITCAIRN' | 'POLAND' | 'PORTUGAL' | 'PUERTO_RICO' | 'QATAR' | 'ROMANIA' | 'RUSSIAN_FEDERATION' | 'RWANDA' | 'RÉUNION' | 'SAINT_BARTHÉLEMY_BL' | 'SAINT_HELENA' | 'SAINT_KITTS_AND_NEVIS' | 'SAINT_LUCIA' | 'SAINT_MARTIN_FRENCH_PART' | 'SAINT_PIERRE_AND_MIQUELON' | 'SAINT_VINCENT_AND_THE_GRENADINES' | 'SAMOA' | 'SAN_MARINO' | 'SAO_TOME_AND_PRINCIPE' | 'SAUDI_ARABIA' | 'SENEGAL' | 'SERBIA' | 'SEYCHELLES' | 'SIERRA_LEONE' | 'SINGAPORE' | 'SINT_MAARTEN_DUTCH_PART' | 'SLOVAKIA' | 'SLOVENIA' | 'SOLOMON_ISLANDS' | 'SOMALIA' | 'SOUTH_AFRICA' | 'SOUTH_GEORGIA_AND_THE_SOUTH_SANDWICH_ISLANDS' | 'SOUTH_SUDAN' | 'SPAIN' | 'SRI_LANKA' | 'SUDAN' | 'SURINAME' | 'SVALBARD_AND_JAN_MAYEN' | 'SWAZILAND' | 'SWEDEN' | 'SWITZERLAND' | 'SYRIAN_ARAB_REPUBLIC' | 'TAIWAN' | 'TAJIKISTAN' | 'THAILAND' | 'THE_FORMER_YUGOSLAV_REPUBLIC_OF_MACEDONIA' | 'TOGO' | 'TOKELAU' | 'TONGA' | 'TRINIDAD_AND_TOBAGO' | 'TUNISIA' | 'TURKEY' | 'TURKMENISTAN' | 'TURKS_AND_CAICOS_ISLANDS' | 'TUVALU' | 'UGANDA' | 'UKRAINE' | 'UNITED_ARAB_EMIRATES' | 'UNITED_KINGDOM' | 'UNITED_REPUBLIC_OF_TANZANIA' | 'UNITED_STATES_MINOR_OUTLYING_ISLANDS' | 'URUGUAY' | 'USA' | 'UZBEKISTAN' | 'VANUATU' | 'VATICAN_CITY_STATE' | 'VENEZUELA' | 'VIET_NAM' | 'VIRGIN_ISLANDS_GB' | 'VIRGIN_ISLANDS_USA' | 'WALLIS_AND_FUTUNA' | 'WESTERN_SAHARA' | 'YEMEN' | 'ZAMBIA' | 'ZIMBABWE' | null
}
export type ClientPropComplianceDataTermsAndConditionsAccepted = {
	[ClientProp.ComplianceDataTermsAndConditionsAccepted] : boolean | null
}
export type ClientPropComplianceDataTermsAndConditionsAcceptedDate = {
	[ClientProp.ComplianceDataTermsAndConditionsAcceptedDate] : number | null
}
export type ClientPropComplianceDataTermsConditionsNewVersion = {
	[ClientProp.ComplianceDataTermsConditionsNewVersion] : 'PENDING' | 'ACCEPTED' | 'DECLINED' | 'POSTPONED' | 'NOT_RELEVANT' | null
}
export type ClientPropComplianceDataTermsConditionsNewVersionTime = {
	[ClientProp.ComplianceDataTermsConditionsNewVersionTime] : number | null
}
export type ClientPropComplianceDataTin = {
	[ClientProp.ComplianceDataTin] : string | null
}
export type ClientPropComplianceDataTin2 = {
	[ClientProp.ComplianceDataTin2] : string | null
}
export type ClientPropComplianceDataTinAbsenceReason = {
	[ClientProp.ComplianceDataTinAbsenceReason] : 'NOT_RELEVANT' | 'DOES_NOT_ISSUE' | 'UNABLE_TO_OBTAIN' | 'NOT_REQUIRED' | 'NOT_TAXABLE_PERSON' | 'PERSON_RECENTLY_MOVED' | null
}
export type ClientPropComplianceDataW8Form = {
	[ClientProp.ComplianceDataW8Form] : boolean | null
}
export type ClientPropComplianceDataWhyCannotObtainTIN = {
	[ClientProp.ComplianceDataWhyCannotObtainTIN] : string | null
}
export type ClientPropComplianceDataWorldCheckFulfilled = {
	[ClientProp.ComplianceDataWorldCheckFulfilled] : boolean | null
}
export type ClientPropCreationTime = {
	[ClientProp.CreationTime] : number | null
}
export type ClientPropCustomerAccountType = {
	[ClientProp.CustomerAccountType] : 'INDIVIDUALS' | 'INDIVIDUALS_HIGH_RISK' | 'INDIVIDUAL_PARTNER' | 'INDIVIDUAL_CLIENT' | 'INDIVIDUAL_LAPI' | 'CORPORATE_COMPANY_WITH_ORDINARY_SHARES' | 'CORPORATE_PARTNER' | 'CORPORATE_CLIENT' | 'CORPORATE_LAPI' | 'CORPORATE_LISTED_COMPANY' | 'CORPORATE_LICENSED_COMPANY' | 'CORPORATE_COMPANY_WITH_BEARER_SHARES' | 'CORPORATE_PARTNERSHIP' | 'CORPORATE_TRUST' | 'CORPORATE_FUNDS' | 'CORPORATE_OTHER' | 'DEALER_ACCOUNT' | 'JOINT_ACCOUNT' | 'MANAGED_AC' | 'INSTITUTIONAL_CLIENTS' | 'HEDGING_COUNTERPARTY' | 'CLEARING_ACCOUNT' | 'OFFSET_ACCOUNT' | 'OMNIBUS_PARTNER' | 'MAM_AC' | 'PROFESSIONAL_CORPORATE' | 'PROFESSIONAL_INDIVIDUAL' | 'PROFESSIONAL_INDIVIDUAL_SPREADBET' | 'RETAIL_CORPORATE' | 'CORPORATE_DATA_SALES_PARTNER' | 'CORPORATE_DATA_DISTRIBUTION_PARTNER' | 'OTHER' | null
}
export type ClientPropCustomerConcat = {
	[ClientProp.CustomerConcat] : string | null
}
export type ClientPropCustomerEntityType = {
	[ClientProp.CustomerEntityType] : 'Individual' | 'Corporate' | null
}
export type ClientPropCustomerFinancesLastActivityDate = {
	[ClientProp.CustomerFinancesLastActivityDate] : number | null
}
export type ClientPropCustomerFinancesTotalCancelledDepositsAmount = {
	[ClientProp.CustomerFinancesTotalCancelledDepositsAmount] : number | null
}
export type ClientPropCustomerFinancesTotalCancelledDepositsCount = {
	[ClientProp.CustomerFinancesTotalCancelledDepositsCount] : number | null
}
export type ClientPropCustomerFinancesTotalDoneDepositsAmount = {
	[ClientProp.CustomerFinancesTotalDoneDepositsAmount] : number | null
}
export type ClientPropCustomerFinancesTotalDoneDepositsCount = {
	[ClientProp.CustomerFinancesTotalDoneDepositsCount] : number | null
}
export type ClientPropCustomerFinancesTotalFailedDepositsAmount = {
	[ClientProp.CustomerFinancesTotalFailedDepositsAmount] : number | null
}
export type ClientPropCustomerFinancesTotalFailedDepositsCount = {
	[ClientProp.CustomerFinancesTotalFailedDepositsCount] : number | null
}
export type ClientPropCustomerFinancesTotalPendingDepositsAmount = {
	[ClientProp.CustomerFinancesTotalPendingDepositsAmount] : number | null
}
export type ClientPropCustomerFinancesTotalPendingDepositsCount = {
	[ClientProp.CustomerFinancesTotalPendingDepositsCount] : number | null
}
export type ClientPropCustomerLoginInfoPasswordCreationTime = {
	[ClientProp.CustomerLoginInfoPasswordCreationTime] : number | null
}
export type ClientPropCustomerStateEngagementState = {
	[ClientProp.CustomerStateEngagementState] : 'PRE_ENGAGED' | 'ENGAGED' | 'NOT_ENGAGED' | 'TRASHED' | 'PRE_LEAD' | 'PENDING_LEAD' | null
}
export type ClientPropCustomerStateModificationTime = {
	[ClientProp.CustomerStateModificationTime] : number | null
}
export type ClientPropCustomerStateNonEngagedType = {
	[ClientProp.CustomerStateNonEngagedType] : 'DISQUALIFIED' | 'BURNOUT' | 'TRASH' | null
}
export type ClientPropDatePOA = {
	[ClientProp.DatePOA] : number | null
}
export type ClientPropDealingRisk = {
	[ClientProp.DealingRisk] : boolean | null
}
export type ClientPropDescription = {
	[ClientProp.Description] : string | null
}
export type ClientPropDisqualificationReason$list = {
	[ClientProp.DisqualificationReason$list] : any /* Entity */
}
export type ClientPropDisqualificationReason$value = {
	[ClientProp.DisqualificationReason$value] : string | null
}
export type ClientPropFinancialRisk = {
	[ClientProp.FinancialRisk] : boolean | null
}
export type ClientPropFirstRegistrationCountry = {
	[ClientProp.FirstRegistrationCountry] : 'NA' | 'AFGHANISTAN' | 'ÅLAND_ISLANDS' | 'ALBANIA' | 'ALGERIA' | 'AMERICAN_SAMOA' | 'ANDORRA' | 'ANGOLA' | 'ANGUILLA' | 'ANTARCTICA' | 'ANTIGUA_AND_BARBUDA' | 'ARGENTINA' | 'ARMENIA' | 'ARUBA' | 'AUSTRALIA' | 'AUSTRIA' | 'AZERBAIJAN' | 'BAHAMAS' | 'BAHRAIN' | 'BANGLADESH' | 'BARBADOS' | 'BELARUS' | 'BELGIUM' | 'BELIZE' | 'BENIN' | 'BERMUDA' | 'BHUTAN' | 'BOLIVIA' | 'BONAIRE_SINT_EUSTATIUS_AND_SABA' | 'BOSNIA_AND_HERZEGOVINA' | 'BOTSWANA' | 'BOUVET_ISLAND' | 'BRAZIL' | 'BRITISH_INDIAN_OCEAN_TERRITORY' | 'BRUNEI_DARUSSALAM' | 'BULGARIA' | 'BURKINA_FASO' | 'BURUNDI' | 'CAMBODIA' | 'CAMEROON' | 'CANADA' | 'CAPE_VERDE' | 'CAYMAN_ISLANDS' | 'CENTRAL_AFRICAN_REPUBLIC' | 'CHAD' | 'CHILE' | 'CHINA' | 'CHRISTMAS_ISLAND' | 'COCOS_ISLANDS' | 'COLOMBIA' | 'COMOROS' | 'CONGO' | 'CONGO_THE_DEMOCRATIC_REPUBLIC_OF_THE' | 'COOK_ISLANDS' | 'COSTA_RICA' | 'CROATIA' | 'CUBA' | 'CURAÇAO' | 'CYPRUS' | 'CZECH_REPUBLIC' | 'CÔTE_DIVOIRE' | 'DENMARK' | 'DJIBOUTI' | 'DOMINICA' | 'DOMINICAN_REPUBLIC' | 'EAST_TIMOR' | 'ECUADOR' | 'EGYPT' | 'EL_SALVADOR' | 'EQUATORIAL_GUINEA' | 'ERITREA' | 'ESTONIA' | 'ETHIOPIA' | 'FALKLAND_ISLANDS' | 'FAROE_ISLANDS' | 'FIJI' | 'FINLAND' | 'FRANCE' | 'FRENCH_GUIANA' | 'FRENCH_POLYNESIA' | 'FRENCH_SOUTHERN_TERRITORIES' | 'GABON' | 'GAMBIA' | 'Georgia' | 'GERMANY' | 'GHANA' | 'GIBRALTAR' | 'GREECE' | 'GREENLAND' | 'GRENADA' | 'GUADELOUPE' | 'GUAM' | 'GUATEMALA' | 'GUERNSEY' | 'GUINEA' | 'GUINEA_BISSAU' | 'GUYANA' | 'HAITI' | 'HEARD_ISLAND_AND_MCDONALD_ISLANDS' | 'HONDURAS' | 'HONG_KONG' | 'Hungary' | 'ICELAND' | 'INDIA' | 'INDONESIA' | 'IRAN' | 'IRAQ' | 'IRELAND' | 'ISLE_OF_MAN' | 'ISRAEL' | 'ITALY' | 'JAMAICA' | 'JAPAN' | 'JERSEY' | 'JORDAN' | 'KAZAKHSTAN' | 'KENYA' | 'KIRIBATI' | 'KOSOVO' | 'KOREA_DEMOCRATIC_PEOPLE_REPUBLIC_OF' | 'KOREA_REPUBLIC_OF' | 'KUWAIT' | 'KYRGYZSTAN' | 'LAO_PEOPLE_DEMOCRATIC_REPUBLIC' | 'LATVIA' | 'LEBANON' | 'LESOTHO' | 'LIBERIA' | 'LIBYAN' | 'LIECHTENSTEIN' | 'LITHUANIA' | 'LUXEMBOURG' | 'MACAO' | 'MADAGASCAR' | 'MALAWI' | 'MALAYSIA' | 'MALDIVES' | 'MALI' | 'MALTA' | 'MARSHALL_ISLANDS' | 'MARTINIQUE' | 'MAURITANIA' | 'MAURITIUS' | 'MAYOTTE' | 'MEXICO' | 'MICRONESIA' | 'MOLDOVA_REPUBLIC_OF' | 'MONACO' | 'MONGOLIA' | 'MONTENEGRO' | 'MONTSERRAT' | 'MOROCCO' | 'MOZAMBIQUE' | 'MYANMAR' | 'NAMIBIA' | 'NAURU' | 'NEPAL' | 'NETHERLANDS' | 'NETHERLANDS_ANTILLES' | 'NEW_CALEDONIA' | 'NEW_ZEALAND' | 'NICARAGUA' | 'NIGER' | 'NIGERIA' | 'NIUE' | 'NORFOLK_ISLAND' | 'NORTHERN_MARIANA_ISLANDS' | 'NORWAY' | 'OMAN' | 'PAKISTAN' | 'PALAU' | 'PALESTINIAN_TERRITORY_OCCUPIED' | 'PANAMA' | 'PAPUA_NEW_GUINEA' | 'PARAGUAY' | 'PERU' | 'PHILIPPINES' | 'PITCAIRN' | 'POLAND' | 'PORTUGAL' | 'PUERTO_RICO' | 'QATAR' | 'ROMANIA' | 'RUSSIAN_FEDERATION' | 'RWANDA' | 'RÉUNION' | 'SAINT_BARTHÉLEMY_BL' | 'SAINT_HELENA' | 'SAINT_KITTS_AND_NEVIS' | 'SAINT_LUCIA' | 'SAINT_MARTIN_FRENCH_PART' | 'SAINT_PIERRE_AND_MIQUELON' | 'SAINT_VINCENT_AND_THE_GRENADINES' | 'SAMOA' | 'SAN_MARINO' | 'SAO_TOME_AND_PRINCIPE' | 'SAUDI_ARABIA' | 'SENEGAL' | 'SERBIA' | 'SEYCHELLES' | 'SIERRA_LEONE' | 'SINGAPORE' | 'SINT_MAARTEN_DUTCH_PART' | 'SLOVAKIA' | 'SLOVENIA' | 'SOLOMON_ISLANDS' | 'SOMALIA' | 'SOUTH_AFRICA' | 'SOUTH_GEORGIA_AND_THE_SOUTH_SANDWICH_ISLANDS' | 'SOUTH_SUDAN' | 'SPAIN' | 'SRI_LANKA' | 'SUDAN' | 'SURINAME' | 'SVALBARD_AND_JAN_MAYEN' | 'SWAZILAND' | 'SWEDEN' | 'SWITZERLAND' | 'SYRIAN_ARAB_REPUBLIC' | 'TAIWAN' | 'TAJIKISTAN' | 'THAILAND' | 'THE_FORMER_YUGOSLAV_REPUBLIC_OF_MACEDONIA' | 'TOGO' | 'TOKELAU' | 'TONGA' | 'TRINIDAD_AND_TOBAGO' | 'TUNISIA' | 'TURKEY' | 'TURKMENISTAN' | 'TURKS_AND_CAICOS_ISLANDS' | 'TUVALU' | 'UGANDA' | 'UKRAINE' | 'UNITED_ARAB_EMIRATES' | 'UNITED_KINGDOM' | 'UNITED_REPUBLIC_OF_TANZANIA' | 'UNITED_STATES_MINOR_OUTLYING_ISLANDS' | 'URUGUAY' | 'USA' | 'UZBEKISTAN' | 'VANUATU' | 'VATICAN_CITY_STATE' | 'VENEZUELA' | 'VIET_NAM' | 'VIRGIN_ISLANDS_GB' | 'VIRGIN_ISLANDS_USA' | 'WALLIS_AND_FUTUNA' | 'WESTERN_SAHARA' | 'YEMEN' | 'ZAMBIA' | 'ZIMBABWE' | null
}
export type ClientPropFullRegistration = {
	[ClientProp.FullRegistration] : boolean | null
}
export type ClientPropId = {
	[ClientProp.Id] : number
}
export type ClientPropInteractionLastLoginCountry = {
	[ClientProp.InteractionLastLoginCountry] : 'NA' | 'AFGHANISTAN' | 'ÅLAND_ISLANDS' | 'ALBANIA' | 'ALGERIA' | 'AMERICAN_SAMOA' | 'ANDORRA' | 'ANGOLA' | 'ANGUILLA' | 'ANTARCTICA' | 'ANTIGUA_AND_BARBUDA' | 'ARGENTINA' | 'ARMENIA' | 'ARUBA' | 'AUSTRALIA' | 'AUSTRIA' | 'AZERBAIJAN' | 'BAHAMAS' | 'BAHRAIN' | 'BANGLADESH' | 'BARBADOS' | 'BELARUS' | 'BELGIUM' | 'BELIZE' | 'BENIN' | 'BERMUDA' | 'BHUTAN' | 'BOLIVIA' | 'BONAIRE_SINT_EUSTATIUS_AND_SABA' | 'BOSNIA_AND_HERZEGOVINA' | 'BOTSWANA' | 'BOUVET_ISLAND' | 'BRAZIL' | 'BRITISH_INDIAN_OCEAN_TERRITORY' | 'BRUNEI_DARUSSALAM' | 'BULGARIA' | 'BURKINA_FASO' | 'BURUNDI' | 'CAMBODIA' | 'CAMEROON' | 'CANADA' | 'CAPE_VERDE' | 'CAYMAN_ISLANDS' | 'CENTRAL_AFRICAN_REPUBLIC' | 'CHAD' | 'CHILE' | 'CHINA' | 'CHRISTMAS_ISLAND' | 'COCOS_ISLANDS' | 'COLOMBIA' | 'COMOROS' | 'CONGO' | 'CONGO_THE_DEMOCRATIC_REPUBLIC_OF_THE' | 'COOK_ISLANDS' | 'COSTA_RICA' | 'CROATIA' | 'CUBA' | 'CURAÇAO' | 'CYPRUS' | 'CZECH_REPUBLIC' | 'CÔTE_DIVOIRE' | 'DENMARK' | 'DJIBOUTI' | 'DOMINICA' | 'DOMINICAN_REPUBLIC' | 'EAST_TIMOR' | 'ECUADOR' | 'EGYPT' | 'EL_SALVADOR' | 'EQUATORIAL_GUINEA' | 'ERITREA' | 'ESTONIA' | 'ETHIOPIA' | 'FALKLAND_ISLANDS' | 'FAROE_ISLANDS' | 'FIJI' | 'FINLAND' | 'FRANCE' | 'FRENCH_GUIANA' | 'FRENCH_POLYNESIA' | 'FRENCH_SOUTHERN_TERRITORIES' | 'GABON' | 'GAMBIA' | 'Georgia' | 'GERMANY' | 'GHANA' | 'GIBRALTAR' | 'GREECE' | 'GREENLAND' | 'GRENADA' | 'GUADELOUPE' | 'GUAM' | 'GUATEMALA' | 'GUERNSEY' | 'GUINEA' | 'GUINEA_BISSAU' | 'GUYANA' | 'HAITI' | 'HEARD_ISLAND_AND_MCDONALD_ISLANDS' | 'HONDURAS' | 'HONG_KONG' | 'Hungary' | 'ICELAND' | 'INDIA' | 'INDONESIA' | 'IRAN' | 'IRAQ' | 'IRELAND' | 'ISLE_OF_MAN' | 'ISRAEL' | 'ITALY' | 'JAMAICA' | 'JAPAN' | 'JERSEY' | 'JORDAN' | 'KAZAKHSTAN' | 'KENYA' | 'KIRIBATI' | 'KOSOVO' | 'KOREA_DEMOCRATIC_PEOPLE_REPUBLIC_OF' | 'KOREA_REPUBLIC_OF' | 'KUWAIT' | 'KYRGYZSTAN' | 'LAO_PEOPLE_DEMOCRATIC_REPUBLIC' | 'LATVIA' | 'LEBANON' | 'LESOTHO' | 'LIBERIA' | 'LIBYAN' | 'LIECHTENSTEIN' | 'LITHUANIA' | 'LUXEMBOURG' | 'MACAO' | 'MADAGASCAR' | 'MALAWI' | 'MALAYSIA' | 'MALDIVES' | 'MALI' | 'MALTA' | 'MARSHALL_ISLANDS' | 'MARTINIQUE' | 'MAURITANIA' | 'MAURITIUS' | 'MAYOTTE' | 'MEXICO' | 'MICRONESIA' | 'MOLDOVA_REPUBLIC_OF' | 'MONACO' | 'MONGOLIA' | 'MONTENEGRO' | 'MONTSERRAT' | 'MOROCCO' | 'MOZAMBIQUE' | 'MYANMAR' | 'NAMIBIA' | 'NAURU' | 'NEPAL' | 'NETHERLANDS' | 'NETHERLANDS_ANTILLES' | 'NEW_CALEDONIA' | 'NEW_ZEALAND' | 'NICARAGUA' | 'NIGER' | 'NIGERIA' | 'NIUE' | 'NORFOLK_ISLAND' | 'NORTHERN_MARIANA_ISLANDS' | 'NORWAY' | 'OMAN' | 'PAKISTAN' | 'PALAU' | 'PALESTINIAN_TERRITORY_OCCUPIED' | 'PANAMA' | 'PAPUA_NEW_GUINEA' | 'PARAGUAY' | 'PERU' | 'PHILIPPINES' | 'PITCAIRN' | 'POLAND' | 'PORTUGAL' | 'PUERTO_RICO' | 'QATAR' | 'ROMANIA' | 'RUSSIAN_FEDERATION' | 'RWANDA' | 'RÉUNION' | 'SAINT_BARTHÉLEMY_BL' | 'SAINT_HELENA' | 'SAINT_KITTS_AND_NEVIS' | 'SAINT_LUCIA' | 'SAINT_MARTIN_FRENCH_PART' | 'SAINT_PIERRE_AND_MIQUELON' | 'SAINT_VINCENT_AND_THE_GRENADINES' | 'SAMOA' | 'SAN_MARINO' | 'SAO_TOME_AND_PRINCIPE' | 'SAUDI_ARABIA' | 'SENEGAL' | 'SERBIA' | 'SEYCHELLES' | 'SIERRA_LEONE' | 'SINGAPORE' | 'SINT_MAARTEN_DUTCH_PART' | 'SLOVAKIA' | 'SLOVENIA' | 'SOLOMON_ISLANDS' | 'SOMALIA' | 'SOUTH_AFRICA' | 'SOUTH_GEORGIA_AND_THE_SOUTH_SANDWICH_ISLANDS' | 'SOUTH_SUDAN' | 'SPAIN' | 'SRI_LANKA' | 'SUDAN' | 'SURINAME' | 'SVALBARD_AND_JAN_MAYEN' | 'SWAZILAND' | 'SWEDEN' | 'SWITZERLAND' | 'SYRIAN_ARAB_REPUBLIC' | 'TAIWAN' | 'TAJIKISTAN' | 'THAILAND' | 'THE_FORMER_YUGOSLAV_REPUBLIC_OF_MACEDONIA' | 'TOGO' | 'TOKELAU' | 'TONGA' | 'TRINIDAD_AND_TOBAGO' | 'TUNISIA' | 'TURKEY' | 'TURKMENISTAN' | 'TURKS_AND_CAICOS_ISLANDS' | 'TUVALU' | 'UGANDA' | 'UKRAINE' | 'UNITED_ARAB_EMIRATES' | 'UNITED_KINGDOM' | 'UNITED_REPUBLIC_OF_TANZANIA' | 'UNITED_STATES_MINOR_OUTLYING_ISLANDS' | 'URUGUAY' | 'USA' | 'UZBEKISTAN' | 'VANUATU' | 'VATICAN_CITY_STATE' | 'VENEZUELA' | 'VIET_NAM' | 'VIRGIN_ISLANDS_GB' | 'VIRGIN_ISLANDS_USA' | 'WALLIS_AND_FUTUNA' | 'WESTERN_SAHARA' | 'YEMEN' | 'ZAMBIA' | 'ZIMBABWE' | null
}
export type ClientPropInteractionLastSource = {
	[ClientProp.InteractionLastSource] : 'WEBSITE' | 'WEBSITE_LOGIN' | 'MT4_CLIENT' | 'SAS' | 'CRM' | 'EXACT_TARGET' | 'C_PATTERN' | 'WEBSITE_REGISTRATION' | 'MT5_CLIENT' | 'ANDROID' | 'IOS' | 'NA' | null
}
export type ClientPropInteractionLoginIp = {
	[ClientProp.InteractionLoginIp] : string | null
}
export type ClientPropInteractionModificationTime = {
	[ClientProp.InteractionModificationTime] : number | null
}
export type ClientPropIp = {
	[ClientProp.Ip] : string | null
}
export type ClientPropJointAccountReason = {
	[ClientProp.JointAccountReason] : string | null
}
export type ClientPropJointPrimaryOwner = {
	[ClientProp.JointPrimaryOwner] : boolean | null
}
export type ClientPropLastRegistrationTime = {
	[ClientProp.LastRegistrationTime] : number | null
}
export type ClientPropLastWorldCheckIdIfMatched = {
	[ClientProp.LastWorldCheckIdIfMatched] : number | null
}
export type ClientPropLeverageLevels = {
	[ClientProp.LeverageLevels] : any /* Entity */
}
export type ClientPropLeverageTypeNames = {
	[ClientProp.LeverageTypeNames] : models.CollectionValueDto<number, never>[]
}
export type ClientPropLoginName = {
	[ClientProp.LoginName] : string | null
}
export type ClientPropManager = {
	[ClientProp.Manager] : string | null
}
export type ClientPropModificationTime = {
	[ClientProp.ModificationTime] : number | null
}
export type ClientPropModifiedBy = {
	[ClientProp.ModifiedBy] : models.UserDto
}
export type ClientPropNpi = {
	[ClientProp.Npi] : string | null
}
export type ClientPropNpiType = {
	[ClientProp.NpiType] : 'ID_NUMBER' | 'PASSPORT' | 'CONCAT' | 'TIN' | 'NCI' | 'LEI' | 'DRIVER_LICENSE' | null
}
export type ClientPropNumberOfDeposits = {
	[ClientProp.NumberOfDeposits] : number | null
}
export type ClientPropNumberOfWithdrawals = {
	[ClientProp.NumberOfWithdrawals] : number | null
}
export type ClientPropOneClickClosingAccountStatus = {
	[ClientProp.OneClickClosingAccountStatus] : 'OPEN' | 'DECLINED' | 'TERMINATED' | null
}
export type ClientPropOneClickClosingAccountStatusGround = {
	[ClientProp.OneClickClosingAccountStatusGround] : 'UNKNOWN' | 'WORLD_CHECK_MATCH' | 'FRAUD_4_DECLINED' | 'CLIENT_PREVIOUSLY_REJECTED_BLACKLISTED' | 'NO_VALID_POI_INABILITY_TO_VERIFY_IDENTITY' | 'NO_VALID_POR_INABILITY_TO_VERIFY_RESIDENCE' | 'APPROPRIATENESS_FAIL' | 'RESIDES_IN_A_BANNED_JURISDICTION' | 'ON_CLIENTS_REQUEST_4_DECLINED' | 'ABUSIVE_BEHAVIOUR' | 'ON_CLIENTS_REQUEST_4_TERMINATED' | 'FRAUD_4_TERMINATED' | 'INACTIVITY' | 'SUSPICIOUS_TRANSACTIONS_ACTIVITIES__AML_RELATED' | 'RESIDES_IN_A_JURISDICTION_SUBSEQUENTLY_BANNED' | 'WORLD_CHECK_MATCH_DURING_MONITORING' | 'MOKAS_REQUEST' | 'INABILITY_TO_CONTACT_CLIENTS_CLIENT_IS_NOT_COOPERATING' | 'UNDERAGE_CLIENT_4_DECLINED' | 'UNDERAGE_CLIENT_4_TERMINATED' | 'TERMINATED_BUSINESS' | 'DECLINED_BUSINESS' | 'ABUSIVE_BEHAVIOUR_DECLINED' | 'TERMINATED_REGULATORY_REASONS' | 'DECLINED_REGULATORY_REASONS' | 'DUPLICATE' | 'SPANISH_CLIENTS_APPROPRIATENESS_FAIL' | 'NEGATIVE_TARGET_ASSESSMENT' | 'VULNERABLE_CLIENT_CONSUMER_DUTY' | 'SELF_EXCLUSION_REQUEST_CONSUMER_DUTY' | 'VULNERABLE_CLIENT_CONSUMER_DUTY_DECLINED' | 'SELF_EXCLUSION_REQUEST_CONSUMER_DUTY_DECLINED' | 'INCOMPLETE_ECONOMIC_PROFILE' | 'SUSPICIOUS_KYC_DOCUMENTS' | 'INABILITY_TO_CONTACT_CLIENT_IS_NOT_COOPERATING' | 'GOVERNANCE_SCORE_FAILED' | 'SUSPICIOUS_KYC_DOCUMENTS_DECLINED' | null
}
export type ClientPropOneClickClosingAccountStatusModificationTime = {
	[ClientProp.OneClickClosingAccountStatusModificationTime] : number | null
}
export type ClientPropOwner = {
	[ClientProp.Owner] : models.UserDto
}
export type ClientPropParentCustomerId = {
	[ClientProp.ParentCustomerId] : number | null
}
export type ClientPropPartnerCompany = {
	[ClientProp.PartnerCompany] : any /* Entity */
}
export type ClientPropPartnerCompany$date = {
	[ClientProp.PartnerCompany$date] : any /* Entity */
}
export type ClientPropPartnerCompany$list = {
	[ClientProp.PartnerCompany$list] : models.CollectionValueDto<number, never>[]
}
export type ClientPropPartnerCompanyName = {
	[ClientProp.PartnerCompanyName] : string | null
}
export type ClientPropPassword = {
	[ClientProp.Password] : string | null
}
export type ClientPropPendingBonusAmount = {
	[ClientProp.PendingBonusAmount] : number | null
}
export type ClientPropPendingBonusAmountUSD = {
	[ClientProp.PendingBonusAmountUSD] : number | null
}
export type ClientPropPendingBonusCurrentPointsAmount = {
	[ClientProp.PendingBonusCurrentPointsAmount] : number | null
}
export type ClientPropPendingBonusExpirationDate = {
	[ClientProp.PendingBonusExpirationDate] : number | null
}
export type ClientPropPendingBonusStatus = {
	[ClientProp.PendingBonusStatus] : number | null
}
export type ClientPropPendingBonusTargetAmountOfPoints = {
	[ClientProp.PendingBonusTargetAmountOfPoints] : number | null
}
export type ClientPropPendingBonusTradingAccountId = {
	[ClientProp.PendingBonusTradingAccountId] : number | null
}
export type ClientPropPersonAddressAddress = {
	[ClientProp.PersonAddressAddress] : string | null
}
export type ClientPropPersonAddressAddress2 = {
	[ClientProp.PersonAddressAddress2] : string | null
}
export type ClientPropPersonAddressCity = {
	[ClientProp.PersonAddressCity] : string | null
}
export type ClientPropPersonAddressZipCode = {
	[ClientProp.PersonAddressZipCode] : string | null
}
export type ClientPropPersonAgeGroup = {
	[ClientProp.PersonAgeGroup] : {maxAge:number; minAge:number; name:string; id:number}
}
export type ClientPropPersonBirthDate = {
	[ClientProp.PersonBirthDate] : number | null
}
export type ClientPropPersonCitizenship = {
	[ClientProp.PersonCitizenship] : 'NA' | 'AFGHANISTAN' | 'ÅLAND_ISLANDS' | 'ALBANIA' | 'ALGERIA' | 'AMERICAN_SAMOA' | 'ANDORRA' | 'ANGOLA' | 'ANGUILLA' | 'ANTARCTICA' | 'ANTIGUA_AND_BARBUDA' | 'ARGENTINA' | 'ARMENIA' | 'ARUBA' | 'AUSTRALIA' | 'AUSTRIA' | 'AZERBAIJAN' | 'BAHAMAS' | 'BAHRAIN' | 'BANGLADESH' | 'BARBADOS' | 'BELARUS' | 'BELGIUM' | 'BELIZE' | 'BENIN' | 'BERMUDA' | 'BHUTAN' | 'BOLIVIA' | 'BONAIRE_SINT_EUSTATIUS_AND_SABA' | 'BOSNIA_AND_HERZEGOVINA' | 'BOTSWANA' | 'BOUVET_ISLAND' | 'BRAZIL' | 'BRITISH_INDIAN_OCEAN_TERRITORY' | 'BRUNEI_DARUSSALAM' | 'BULGARIA' | 'BURKINA_FASO' | 'BURUNDI' | 'CAMBODIA' | 'CAMEROON' | 'CANADA' | 'CAPE_VERDE' | 'CAYMAN_ISLANDS' | 'CENTRAL_AFRICAN_REPUBLIC' | 'CHAD' | 'CHILE' | 'CHINA' | 'CHRISTMAS_ISLAND' | 'COCOS_ISLANDS' | 'COLOMBIA' | 'COMOROS' | 'CONGO' | 'CONGO_THE_DEMOCRATIC_REPUBLIC_OF_THE' | 'COOK_ISLANDS' | 'COSTA_RICA' | 'CROATIA' | 'CUBA' | 'CURAÇAO' | 'CYPRUS' | 'CZECH_REPUBLIC' | 'CÔTE_DIVOIRE' | 'DENMARK' | 'DJIBOUTI' | 'DOMINICA' | 'DOMINICAN_REPUBLIC' | 'EAST_TIMOR' | 'ECUADOR' | 'EGYPT' | 'EL_SALVADOR' | 'EQUATORIAL_GUINEA' | 'ERITREA' | 'ESTONIA' | 'ETHIOPIA' | 'FALKLAND_ISLANDS' | 'FAROE_ISLANDS' | 'FIJI' | 'FINLAND' | 'FRANCE' | 'FRENCH_GUIANA' | 'FRENCH_POLYNESIA' | 'FRENCH_SOUTHERN_TERRITORIES' | 'GABON' | 'GAMBIA' | 'Georgia' | 'GERMANY' | 'GHANA' | 'GIBRALTAR' | 'GREECE' | 'GREENLAND' | 'GRENADA' | 'GUADELOUPE' | 'GUAM' | 'GUATEMALA' | 'GUERNSEY' | 'GUINEA' | 'GUINEA_BISSAU' | 'GUYANA' | 'HAITI' | 'HEARD_ISLAND_AND_MCDONALD_ISLANDS' | 'HONDURAS' | 'HONG_KONG' | 'Hungary' | 'ICELAND' | 'INDIA' | 'INDONESIA' | 'IRAN' | 'IRAQ' | 'IRELAND' | 'ISLE_OF_MAN' | 'ISRAEL' | 'ITALY' | 'JAMAICA' | 'JAPAN' | 'JERSEY' | 'JORDAN' | 'KAZAKHSTAN' | 'KENYA' | 'KIRIBATI' | 'KOSOVO' | 'KOREA_DEMOCRATIC_PEOPLE_REPUBLIC_OF' | 'KOREA_REPUBLIC_OF' | 'KUWAIT' | 'KYRGYZSTAN' | 'LAO_PEOPLE_DEMOCRATIC_REPUBLIC' | 'LATVIA' | 'LEBANON' | 'LESOTHO' | 'LIBERIA' | 'LIBYAN' | 'LIECHTENSTEIN' | 'LITHUANIA' | 'LUXEMBOURG' | 'MACAO' | 'MADAGASCAR' | 'MALAWI' | 'MALAYSIA' | 'MALDIVES' | 'MALI' | 'MALTA' | 'MARSHALL_ISLANDS' | 'MARTINIQUE' | 'MAURITANIA' | 'MAURITIUS' | 'MAYOTTE' | 'MEXICO' | 'MICRONESIA' | 'MOLDOVA_REPUBLIC_OF' | 'MONACO' | 'MONGOLIA' | 'MONTENEGRO' | 'MONTSERRAT' | 'MOROCCO' | 'MOZAMBIQUE' | 'MYANMAR' | 'NAMIBIA' | 'NAURU' | 'NEPAL' | 'NETHERLANDS' | 'NETHERLANDS_ANTILLES' | 'NEW_CALEDONIA' | 'NEW_ZEALAND' | 'NICARAGUA' | 'NIGER' | 'NIGERIA' | 'NIUE' | 'NORFOLK_ISLAND' | 'NORTHERN_MARIANA_ISLANDS' | 'NORWAY' | 'OMAN' | 'PAKISTAN' | 'PALAU' | 'PALESTINIAN_TERRITORY_OCCUPIED' | 'PANAMA' | 'PAPUA_NEW_GUINEA' | 'PARAGUAY' | 'PERU' | 'PHILIPPINES' | 'PITCAIRN' | 'POLAND' | 'PORTUGAL' | 'PUERTO_RICO' | 'QATAR' | 'ROMANIA' | 'RUSSIAN_FEDERATION' | 'RWANDA' | 'RÉUNION' | 'SAINT_BARTHÉLEMY_BL' | 'SAINT_HELENA' | 'SAINT_KITTS_AND_NEVIS' | 'SAINT_LUCIA' | 'SAINT_MARTIN_FRENCH_PART' | 'SAINT_PIERRE_AND_MIQUELON' | 'SAINT_VINCENT_AND_THE_GRENADINES' | 'SAMOA' | 'SAN_MARINO' | 'SAO_TOME_AND_PRINCIPE' | 'SAUDI_ARABIA' | 'SENEGAL' | 'SERBIA' | 'SEYCHELLES' | 'SIERRA_LEONE' | 'SINGAPORE' | 'SINT_MAARTEN_DUTCH_PART' | 'SLOVAKIA' | 'SLOVENIA' | 'SOLOMON_ISLANDS' | 'SOMALIA' | 'SOUTH_AFRICA' | 'SOUTH_GEORGIA_AND_THE_SOUTH_SANDWICH_ISLANDS' | 'SOUTH_SUDAN' | 'SPAIN' | 'SRI_LANKA' | 'SUDAN' | 'SURINAME' | 'SVALBARD_AND_JAN_MAYEN' | 'SWAZILAND' | 'SWEDEN' | 'SWITZERLAND' | 'SYRIAN_ARAB_REPUBLIC' | 'TAIWAN' | 'TAJIKISTAN' | 'THAILAND' | 'THE_FORMER_YUGOSLAV_REPUBLIC_OF_MACEDONIA' | 'TOGO' | 'TOKELAU' | 'TONGA' | 'TRINIDAD_AND_TOBAGO' | 'TUNISIA' | 'TURKEY' | 'TURKMENISTAN' | 'TURKS_AND_CAICOS_ISLANDS' | 'TUVALU' | 'UGANDA' | 'UKRAINE' | 'UNITED_ARAB_EMIRATES' | 'UNITED_KINGDOM' | 'UNITED_REPUBLIC_OF_TANZANIA' | 'UNITED_STATES_MINOR_OUTLYING_ISLANDS' | 'URUGUAY' | 'USA' | 'UZBEKISTAN' | 'VANUATU' | 'VATICAN_CITY_STATE' | 'VENEZUELA' | 'VIET_NAM' | 'VIRGIN_ISLANDS_GB' | 'VIRGIN_ISLANDS_USA' | 'WALLIS_AND_FUTUNA' | 'WESTERN_SAHARA' | 'YEMEN' | 'ZAMBIA' | 'ZIMBABWE' | null
}
export type ClientPropPersonCountry = {
	[ClientProp.PersonCountry] : 'NA' | 'AFGHANISTAN' | 'ÅLAND_ISLANDS' | 'ALBANIA' | 'ALGERIA' | 'AMERICAN_SAMOA' | 'ANDORRA' | 'ANGOLA' | 'ANGUILLA' | 'ANTARCTICA' | 'ANTIGUA_AND_BARBUDA' | 'ARGENTINA' | 'ARMENIA' | 'ARUBA' | 'AUSTRALIA' | 'AUSTRIA' | 'AZERBAIJAN' | 'BAHAMAS' | 'BAHRAIN' | 'BANGLADESH' | 'BARBADOS' | 'BELARUS' | 'BELGIUM' | 'BELIZE' | 'BENIN' | 'BERMUDA' | 'BHUTAN' | 'BOLIVIA' | 'BONAIRE_SINT_EUSTATIUS_AND_SABA' | 'BOSNIA_AND_HERZEGOVINA' | 'BOTSWANA' | 'BOUVET_ISLAND' | 'BRAZIL' | 'BRITISH_INDIAN_OCEAN_TERRITORY' | 'BRUNEI_DARUSSALAM' | 'BULGARIA' | 'BURKINA_FASO' | 'BURUNDI' | 'CAMBODIA' | 'CAMEROON' | 'CANADA' | 'CAPE_VERDE' | 'CAYMAN_ISLANDS' | 'CENTRAL_AFRICAN_REPUBLIC' | 'CHAD' | 'CHILE' | 'CHINA' | 'CHRISTMAS_ISLAND' | 'COCOS_ISLANDS' | 'COLOMBIA' | 'COMOROS' | 'CONGO' | 'CONGO_THE_DEMOCRATIC_REPUBLIC_OF_THE' | 'COOK_ISLANDS' | 'COSTA_RICA' | 'CROATIA' | 'CUBA' | 'CURAÇAO' | 'CYPRUS' | 'CZECH_REPUBLIC' | 'CÔTE_DIVOIRE' | 'DENMARK' | 'DJIBOUTI' | 'DOMINICA' | 'DOMINICAN_REPUBLIC' | 'EAST_TIMOR' | 'ECUADOR' | 'EGYPT' | 'EL_SALVADOR' | 'EQUATORIAL_GUINEA' | 'ERITREA' | 'ESTONIA' | 'ETHIOPIA' | 'FALKLAND_ISLANDS' | 'FAROE_ISLANDS' | 'FIJI' | 'FINLAND' | 'FRANCE' | 'FRENCH_GUIANA' | 'FRENCH_POLYNESIA' | 'FRENCH_SOUTHERN_TERRITORIES' | 'GABON' | 'GAMBIA' | 'Georgia' | 'GERMANY' | 'GHANA' | 'GIBRALTAR' | 'GREECE' | 'GREENLAND' | 'GRENADA' | 'GUADELOUPE' | 'GUAM' | 'GUATEMALA' | 'GUERNSEY' | 'GUINEA' | 'GUINEA_BISSAU' | 'GUYANA' | 'HAITI' | 'HEARD_ISLAND_AND_MCDONALD_ISLANDS' | 'HONDURAS' | 'HONG_KONG' | 'Hungary' | 'ICELAND' | 'INDIA' | 'INDONESIA' | 'IRAN' | 'IRAQ' | 'IRELAND' | 'ISLE_OF_MAN' | 'ISRAEL' | 'ITALY' | 'JAMAICA' | 'JAPAN' | 'JERSEY' | 'JORDAN' | 'KAZAKHSTAN' | 'KENYA' | 'KIRIBATI' | 'KOSOVO' | 'KOREA_DEMOCRATIC_PEOPLE_REPUBLIC_OF' | 'KOREA_REPUBLIC_OF' | 'KUWAIT' | 'KYRGYZSTAN' | 'LAO_PEOPLE_DEMOCRATIC_REPUBLIC' | 'LATVIA' | 'LEBANON' | 'LESOTHO' | 'LIBERIA' | 'LIBYAN' | 'LIECHTENSTEIN' | 'LITHUANIA' | 'LUXEMBOURG' | 'MACAO' | 'MADAGASCAR' | 'MALAWI' | 'MALAYSIA' | 'MALDIVES' | 'MALI' | 'MALTA' | 'MARSHALL_ISLANDS' | 'MARTINIQUE' | 'MAURITANIA' | 'MAURITIUS' | 'MAYOTTE' | 'MEXICO' | 'MICRONESIA' | 'MOLDOVA_REPUBLIC_OF' | 'MONACO' | 'MONGOLIA' | 'MONTENEGRO' | 'MONTSERRAT' | 'MOROCCO' | 'MOZAMBIQUE' | 'MYANMAR' | 'NAMIBIA' | 'NAURU' | 'NEPAL' | 'NETHERLANDS' | 'NETHERLANDS_ANTILLES' | 'NEW_CALEDONIA' | 'NEW_ZEALAND' | 'NICARAGUA' | 'NIGER' | 'NIGERIA' | 'NIUE' | 'NORFOLK_ISLAND' | 'NORTHERN_MARIANA_ISLANDS' | 'NORWAY' | 'OMAN' | 'PAKISTAN' | 'PALAU' | 'PALESTINIAN_TERRITORY_OCCUPIED' | 'PANAMA' | 'PAPUA_NEW_GUINEA' | 'PARAGUAY' | 'PERU' | 'PHILIPPINES' | 'PITCAIRN' | 'POLAND' | 'PORTUGAL' | 'PUERTO_RICO' | 'QATAR' | 'ROMANIA' | 'RUSSIAN_FEDERATION' | 'RWANDA' | 'RÉUNION' | 'SAINT_BARTHÉLEMY_BL' | 'SAINT_HELENA' | 'SAINT_KITTS_AND_NEVIS' | 'SAINT_LUCIA' | 'SAINT_MARTIN_FRENCH_PART' | 'SAINT_PIERRE_AND_MIQUELON' | 'SAINT_VINCENT_AND_THE_GRENADINES' | 'SAMOA' | 'SAN_MARINO' | 'SAO_TOME_AND_PRINCIPE' | 'SAUDI_ARABIA' | 'SENEGAL' | 'SERBIA' | 'SEYCHELLES' | 'SIERRA_LEONE' | 'SINGAPORE' | 'SINT_MAARTEN_DUTCH_PART' | 'SLOVAKIA' | 'SLOVENIA' | 'SOLOMON_ISLANDS' | 'SOMALIA' | 'SOUTH_AFRICA' | 'SOUTH_GEORGIA_AND_THE_SOUTH_SANDWICH_ISLANDS' | 'SOUTH_SUDAN' | 'SPAIN' | 'SRI_LANKA' | 'SUDAN' | 'SURINAME' | 'SVALBARD_AND_JAN_MAYEN' | 'SWAZILAND' | 'SWEDEN' | 'SWITZERLAND' | 'SYRIAN_ARAB_REPUBLIC' | 'TAIWAN' | 'TAJIKISTAN' | 'THAILAND' | 'THE_FORMER_YUGOSLAV_REPUBLIC_OF_MACEDONIA' | 'TOGO' | 'TOKELAU' | 'TONGA' | 'TRINIDAD_AND_TOBAGO' | 'TUNISIA' | 'TURKEY' | 'TURKMENISTAN' | 'TURKS_AND_CAICOS_ISLANDS' | 'TUVALU' | 'UGANDA' | 'UKRAINE' | 'UNITED_ARAB_EMIRATES' | 'UNITED_KINGDOM' | 'UNITED_REPUBLIC_OF_TANZANIA' | 'UNITED_STATES_MINOR_OUTLYING_ISLANDS' | 'URUGUAY' | 'USA' | 'UZBEKISTAN' | 'VANUATU' | 'VATICAN_CITY_STATE' | 'VENEZUELA' | 'VIET_NAM' | 'VIRGIN_ISLANDS_GB' | 'VIRGIN_ISLANDS_USA' | 'WALLIS_AND_FUTUNA' | 'WESTERN_SAHARA' | 'YEMEN' | 'ZAMBIA' | 'ZIMBABWE' | null
}
export type ClientPropPersonCountry$list = {
	[ClientProp.PersonCountry$list] : models.CollectionValueDto<null, models.CountryPayloadDto>[]
}
export type ClientPropPersonCountry$payload = {
	[ClientProp.PersonCountry$payload] : models.CountryPayloadDto | null
}
export type ClientPropPersonDriverLicense = {
	[ClientProp.PersonDriverLicense] : string | null
}
export type ClientPropPersonEmail1EmailAddress = {
	[ClientProp.PersonEmail1EmailAddress] : string | null
}
export type ClientPropPersonEmail1Verified = {
	[ClientProp.PersonEmail1Verified] : 'UNKNOWN' | 'VERIFIED' | 'NOT_VERIFIED' | 'INVALID' | 'VERIFIED_BY_SMS' | null
}
export type ClientPropPersonEmail2EmailAddress = {
	[ClientProp.PersonEmail2EmailAddress] : string | null
}
export type ClientPropPersonEmail2Verified = {
	[ClientProp.PersonEmail2Verified] : 'UNKNOWN' | 'VERIFIED' | 'NOT_VERIFIED' | 'INVALID' | 'VERIFIED_BY_SMS' | null
}
export type ClientPropPersonFirstName = {
	[ClientProp.PersonFirstName] : string | null
}
export type ClientPropPersonFirstNameEnglish = {
	[ClientProp.PersonFirstNameEnglish] : string | null
}
export type ClientPropPersonGender = {
	[ClientProp.PersonGender] : 'UNKNOWN' | 'MALE' | 'FEMALE' | null
}
export type ClientPropPersonIdNumber = {
	[ClientProp.PersonIdNumber] : string | null
}
export type ClientPropPersonLanguage = {
	[ClientProp.PersonLanguage] : 'OTHER' | 'ALBANIAN' | 'ARABIC' | 'BULGARIAN' | 'CATALAN' | 'CHINESE' | 'CHINESETR' | 'CROATIAN' | 'CZECH' | 'DANISH' | 'DUTCH' | 'ENGLISH' | 'ESTONIAN' | 'FINNISH' | 'FRENCH' | 'GALICIAN' | 'GERMAN' | 'GREEK' | 'HEBREW' | 'HINDI' | 'HUNGARIAN' | 'INDONESIAN' | 'ITALIAN' | 'JAPANESE' | 'KOREAN' | 'LATVIAN' | 'LITHUANIAN' | 'MALAY' | 'MALTESE' | 'NORWEGIAN' | 'PERSIAN' | 'POLISH' | 'PORTUGUESE' | 'PUNJABI' | 'ROMANIAN' | 'RUSSIAN' | 'SERBIAN' | 'SLOVAK' | 'SLOVENIAN' | 'SPANISH' | 'SWEDISH' | 'TAGALOG' | 'THAI' | 'TURKISH' | 'UKRAINIAN' | 'URDU' | 'VIETNAMESE' | null
}
export type ClientPropPersonLanguageDbValue = {
	[ClientProp.PersonLanguageDbValue] : string | null
}
export type ClientPropPersonLastName = {
	[ClientProp.PersonLastName] : string | null
}
export type ClientPropPersonLastNameEnglish = {
	[ClientProp.PersonLastNameEnglish] : string | null
}
export type ClientPropPersonLei = {
	[ClientProp.PersonLei] : string | null
}
export type ClientPropPersonLeiExpirationDate = {
	[ClientProp.PersonLeiExpirationDate] : number | null
}
export type ClientPropPersonNameEnglish = {
	[ClientProp.PersonNameEnglish] : string | null
}
export type ClientPropPersonNationality = {
	[ClientProp.PersonNationality] : 'NA' | 'AFGHANISTAN' | 'ÅLAND_ISLANDS' | 'ALBANIA' | 'ALGERIA' | 'AMERICAN_SAMOA' | 'ANDORRA' | 'ANGOLA' | 'ANGUILLA' | 'ANTARCTICA' | 'ANTIGUA_AND_BARBUDA' | 'ARGENTINA' | 'ARMENIA' | 'ARUBA' | 'AUSTRALIA' | 'AUSTRIA' | 'AZERBAIJAN' | 'BAHAMAS' | 'BAHRAIN' | 'BANGLADESH' | 'BARBADOS' | 'BELARUS' | 'BELGIUM' | 'BELIZE' | 'BENIN' | 'BERMUDA' | 'BHUTAN' | 'BOLIVIA' | 'BONAIRE_SINT_EUSTATIUS_AND_SABA' | 'BOSNIA_AND_HERZEGOVINA' | 'BOTSWANA' | 'BOUVET_ISLAND' | 'BRAZIL' | 'BRITISH_INDIAN_OCEAN_TERRITORY' | 'BRUNEI_DARUSSALAM' | 'BULGARIA' | 'BURKINA_FASO' | 'BURUNDI' | 'CAMBODIA' | 'CAMEROON' | 'CANADA' | 'CAPE_VERDE' | 'CAYMAN_ISLANDS' | 'CENTRAL_AFRICAN_REPUBLIC' | 'CHAD' | 'CHILE' | 'CHINA' | 'CHRISTMAS_ISLAND' | 'COCOS_ISLANDS' | 'COLOMBIA' | 'COMOROS' | 'CONGO' | 'CONGO_THE_DEMOCRATIC_REPUBLIC_OF_THE' | 'COOK_ISLANDS' | 'COSTA_RICA' | 'CROATIA' | 'CUBA' | 'CURAÇAO' | 'CYPRUS' | 'CZECH_REPUBLIC' | 'CÔTE_DIVOIRE' | 'DENMARK' | 'DJIBOUTI' | 'DOMINICA' | 'DOMINICAN_REPUBLIC' | 'EAST_TIMOR' | 'ECUADOR' | 'EGYPT' | 'EL_SALVADOR' | 'EQUATORIAL_GUINEA' | 'ERITREA' | 'ESTONIA' | 'ETHIOPIA' | 'FALKLAND_ISLANDS' | 'FAROE_ISLANDS' | 'FIJI' | 'FINLAND' | 'FRANCE' | 'FRENCH_GUIANA' | 'FRENCH_POLYNESIA' | 'FRENCH_SOUTHERN_TERRITORIES' | 'GABON' | 'GAMBIA' | 'Georgia' | 'GERMANY' | 'GHANA' | 'GIBRALTAR' | 'GREECE' | 'GREENLAND' | 'GRENADA' | 'GUADELOUPE' | 'GUAM' | 'GUATEMALA' | 'GUERNSEY' | 'GUINEA' | 'GUINEA_BISSAU' | 'GUYANA' | 'HAITI' | 'HEARD_ISLAND_AND_MCDONALD_ISLANDS' | 'HONDURAS' | 'HONG_KONG' | 'Hungary' | 'ICELAND' | 'INDIA' | 'INDONESIA' | 'IRAN' | 'IRAQ' | 'IRELAND' | 'ISLE_OF_MAN' | 'ISRAEL' | 'ITALY' | 'JAMAICA' | 'JAPAN' | 'JERSEY' | 'JORDAN' | 'KAZAKHSTAN' | 'KENYA' | 'KIRIBATI' | 'KOSOVO' | 'KOREA_DEMOCRATIC_PEOPLE_REPUBLIC_OF' | 'KOREA_REPUBLIC_OF' | 'KUWAIT' | 'KYRGYZSTAN' | 'LAO_PEOPLE_DEMOCRATIC_REPUBLIC' | 'LATVIA' | 'LEBANON' | 'LESOTHO' | 'LIBERIA' | 'LIBYAN' | 'LIECHTENSTEIN' | 'LITHUANIA' | 'LUXEMBOURG' | 'MACAO' | 'MADAGASCAR' | 'MALAWI' | 'MALAYSIA' | 'MALDIVES' | 'MALI' | 'MALTA' | 'MARSHALL_ISLANDS' | 'MARTINIQUE' | 'MAURITANIA' | 'MAURITIUS' | 'MAYOTTE' | 'MEXICO' | 'MICRONESIA' | 'MOLDOVA_REPUBLIC_OF' | 'MONACO' | 'MONGOLIA' | 'MONTENEGRO' | 'MONTSERRAT' | 'MOROCCO' | 'MOZAMBIQUE' | 'MYANMAR' | 'NAMIBIA' | 'NAURU' | 'NEPAL' | 'NETHERLANDS' | 'NETHERLANDS_ANTILLES' | 'NEW_CALEDONIA' | 'NEW_ZEALAND' | 'NICARAGUA' | 'NIGER' | 'NIGERIA' | 'NIUE' | 'NORFOLK_ISLAND' | 'NORTHERN_MARIANA_ISLANDS' | 'NORWAY' | 'OMAN' | 'PAKISTAN' | 'PALAU' | 'PALESTINIAN_TERRITORY_OCCUPIED' | 'PANAMA' | 'PAPUA_NEW_GUINEA' | 'PARAGUAY' | 'PERU' | 'PHILIPPINES' | 'PITCAIRN' | 'POLAND' | 'PORTUGAL' | 'PUERTO_RICO' | 'QATAR' | 'ROMANIA' | 'RUSSIAN_FEDERATION' | 'RWANDA' | 'RÉUNION' | 'SAINT_BARTHÉLEMY_BL' | 'SAINT_HELENA' | 'SAINT_KITTS_AND_NEVIS' | 'SAINT_LUCIA' | 'SAINT_MARTIN_FRENCH_PART' | 'SAINT_PIERRE_AND_MIQUELON' | 'SAINT_VINCENT_AND_THE_GRENADINES' | 'SAMOA' | 'SAN_MARINO' | 'SAO_TOME_AND_PRINCIPE' | 'SAUDI_ARABIA' | 'SENEGAL' | 'SERBIA' | 'SEYCHELLES' | 'SIERRA_LEONE' | 'SINGAPORE' | 'SINT_MAARTEN_DUTCH_PART' | 'SLOVAKIA' | 'SLOVENIA' | 'SOLOMON_ISLANDS' | 'SOMALIA' | 'SOUTH_AFRICA' | 'SOUTH_GEORGIA_AND_THE_SOUTH_SANDWICH_ISLANDS' | 'SOUTH_SUDAN' | 'SPAIN' | 'SRI_LANKA' | 'SUDAN' | 'SURINAME' | 'SVALBARD_AND_JAN_MAYEN' | 'SWAZILAND' | 'SWEDEN' | 'SWITZERLAND' | 'SYRIAN_ARAB_REPUBLIC' | 'TAIWAN' | 'TAJIKISTAN' | 'THAILAND' | 'THE_FORMER_YUGOSLAV_REPUBLIC_OF_MACEDONIA' | 'TOGO' | 'TOKELAU' | 'TONGA' | 'TRINIDAD_AND_TOBAGO' | 'TUNISIA' | 'TURKEY' | 'TURKMENISTAN' | 'TURKS_AND_CAICOS_ISLANDS' | 'TUVALU' | 'UGANDA' | 'UKRAINE' | 'UNITED_ARAB_EMIRATES' | 'UNITED_KINGDOM' | 'UNITED_REPUBLIC_OF_TANZANIA' | 'UNITED_STATES_MINOR_OUTLYING_ISLANDS' | 'URUGUAY' | 'USA' | 'UZBEKISTAN' | 'VANUATU' | 'VATICAN_CITY_STATE' | 'VENEZUELA' | 'VIET_NAM' | 'VIRGIN_ISLANDS_GB' | 'VIRGIN_ISLANDS_USA' | 'WALLIS_AND_FUTUNA' | 'WESTERN_SAHARA' | 'YEMEN' | 'ZAMBIA' | 'ZIMBABWE' | null
}
export type ClientPropPersonPassport = {
	[ClientProp.PersonPassport] : string | null
}
export type ClientPropPersonPhone1CountryCode = {
	[ClientProp.PersonPhone1CountryCode] : string | null
}
export type ClientPropPersonPhone1Num = {
	[ClientProp.PersonPhone1Num] : string | null
}
export type ClientPropPersonPhone1Verified = {
	[ClientProp.PersonPhone1Verified] : 'UNKNOWN' | 'VERIFIED' | 'NOT_VERIFIED' | 'INVALID' | 'VERIFIED_BY_SMS' | null
}
export type ClientPropPersonPhone2CountryCode = {
	[ClientProp.PersonPhone2CountryCode] : string | null
}
export type ClientPropPersonPhone2Num = {
	[ClientProp.PersonPhone2Num] : string | null
}
export type ClientPropPersonPhone2Verified = {
	[ClientProp.PersonPhone2Verified] : 'UNKNOWN' | 'VERIFIED' | 'NOT_VERIFIED' | 'INVALID' | 'VERIFIED_BY_SMS' | null
}
export type ClientPropPersonPhone4Num = {
	[ClientProp.PersonPhone4Num] : string | null
}
export type ClientPropPoiExpirationDays = {
	[ClientProp.PoiExpirationDays] : number | null
}
export type ClientPropPorExpirationDays = {
	[ClientProp.PorExpirationDays] : number | null
}
export type ClientPropRealTradingAccountCount = {
	[ClientProp.RealTradingAccountCount] : number | null
}
export type ClientPropRegistrationCompanySelection = {
	[ClientProp.RegistrationCompanySelection] : boolean | null
}
export type ClientPropRegistrationMarketingParamsCampaign = {
	[ClientProp.RegistrationMarketingParamsCampaign] : string | null
}
export type ClientPropRegistrationMarketingParamsReferrer = {
	[ClientProp.RegistrationMarketingParamsReferrer] : string | null
}
export type ClientPropRegistrationTrafficSourceAffiliateId = {
	[ClientProp.RegistrationTrafficSourceAffiliateId] : string | null
}
export type ClientPropRegistrationTrafficSourceAffiliateId$affiliateRemark = {
	[ClientProp.RegistrationTrafficSourceAffiliateId$affiliateRemark] : string | null
}
export type ClientPropRegistrationTrafficSourceLandingPage = {
	[ClientProp.RegistrationTrafficSourceLandingPage] : any /* Entity */
}
export type ClientPropRegistrationTrafficSourceMedia = {
	[ClientProp.RegistrationTrafficSourceMedia] : string | null
}
export type ClientPropRegistrationTrafficSourceNetwork = {
	[ClientProp.RegistrationTrafficSourceNetwork] : string | null
}
export type ClientPropRegistrationTrafficSourcePromotionName = {
	[ClientProp.RegistrationTrafficSourcePromotionName] : string | null
}
export type ClientPropRegistrationTrafficSourceTrafficId = {
	[ClientProp.RegistrationTrafficSourceTrafficId] : string | null
}
export type ClientPropRegistrationTrafficSourceZone = {
	[ClientProp.RegistrationTrafficSourceZone] : string | null
}
export type ClientPropRegistrationStatus = {
	[ClientProp.RegistrationStatus] : 'LEAD' | 'DEMO' | 'REAL' | 'REAL_FUNDED' | null
}
export type ClientPropRegistrationsCount = {
	[ClientProp.RegistrationsCount] : number | null
}
export type ClientPropRegulationTypeName = {
	[ClientProp.RegulationTypeName] : string | null
}
export type ClientPropSecurityAnswer = {
	[ClientProp.SecurityAnswer] : string | null
}
export type ClientPropSecurityQuestion = {
	[ClientProp.SecurityQuestion] : 'MOTHERS_MAIDEN_NAME' | 'FAVORITE_TEACHERS_NAME' | 'FAVORITE_TV_PROGRAM' | 'FAVORITE_COLOR' | 'FAVORITE_SPORTS_TEAM_NAME' | 'PETS_NAME' | null
}
export type ClientPropTotalDeposits = {
	[ClientProp.TotalDeposits] : number | null
}
export type ClientPropTotalWithdrawals = {
	[ClientProp.TotalWithdrawals] : number | null
}
export type ClientPropTradingTotalsRealEquity = {
	[ClientProp.TradingTotalsRealEquity] : number | null
}


export type Client = 
	ClientPropAssignedPoolName & 
	ClientPropAssignedUser & 
	ClientPropAvailableProducts & 
	ClientPropBlacklisted & 
	ClientPropBrandName & 
	ClientPropCompanyRegulationCountryCompanyRegulationGracePeriodScoreLevels & 
	ClientPropComplianceDataAllowDeposits & 
	ClientPropComplianceDataAmlClassificationStatus & 
	ClientPropComplianceDataAmlCustomerQuestionnaireName & 
	ClientPropComplianceDataAmlCustomerQuestionnaireQuestionnaireId & 
	ClientPropComplianceDataAmlCustomerQuestionnaireScore & 
	ClientPropComplianceDataAmlCustomerQuestionnaireScoreCategory & 
	ClientPropComplianceDataClientClassification & 
	ClientPropComplianceDataComment & 
	ClientPropComplianceDataComplianceApprovedDate & 
	ClientPropComplianceDataComplianceStage & 
	ClientPropComplianceDataComplianceStage$list & 
	ClientPropComplianceDataComplianceSuspendedGround & 
	ClientPropComplianceDataComplianceSuspensionDate & 
	ClientPropComplianceDataCustomerECDDPhone & 
	ClientPropComplianceDataCustomerQuestionnaireFullyRegistered & 
	ClientPropComplianceDataCustomerQuestionnaireName & 
	ClientPropComplianceDataCustomerQuestionnaireQuestionnaireId & 
	ClientPropComplianceDataCustomerQuestionnaireScore & 
	ClientPropComplianceDataCustomerQuestionnaireScoreCategoryScoreLevel & 
	ClientPropComplianceDataEcddOptions & 
	ClientPropComplianceDataEcddPerformed & 
	ClientPropComplianceDataEvAgreement & 
	ClientPropComplianceDataEvAgreementDate & 
	ClientPropComplianceDataFatca & 
	ClientPropComplianceDataFirstDepositCountry & 
	ClientPropComplianceDataFirstDepositCountry$payload & 
	ClientPropComplianceDataFirstEyeApproved & 
	ClientPropComplianceDataFirstEyeComplianceApprover & 
	ClientPropComplianceDataFullRegistrationBonusTermsAndConditionsAccepted & 
	ClientPropComplianceDataFullRegistrationIp & 
	ClientPropComplianceDataGbgApproved & 
	ClientPropComplianceDataGbgApprovedDate & 
	ClientPropComplianceDataGbgApprovedStatus & 
	ClientPropComplianceDataGbgAuthenticationId & 
	ClientPropComplianceDataGracePeriodDuration & 
	ClientPropComplianceDataGracePeriodEligible & 
	ClientPropComplianceDataGracePeriodStatus & 
	ClientPropComplianceDataHasLivenessTest & 
	ClientPropComplianceDataHasProofOfId & 
	ClientPropComplianceDataHasProofOfResidence & 
	ClientPropComplianceDataLowScoreCautionAcceptedDate & 
	ClientPropComplianceDataLowScoreWarningAccepted & 
	ClientPropComplianceDataMediumScoreCautionAccepted & 
	ClientPropComplianceDataMediumScoreCautionAcceptedDate & 
	ClientPropComplianceDataNci & 
	ClientPropComplianceDataNciStatus & 
	ClientPropComplianceDataNewTradingAccountForbidden & 
	ClientPropComplianceDataPendingComplianceGround & 
	ClientPropComplianceDataPersonalInformationConfirmed & 
	ClientPropComplianceDataPersonalInformationConfirmedDate & 
	ClientPropComplianceDataPoiExpirationDate & 
	ClientPropComplianceDataPoliticallyExposedPerson & 
	ClientPropComplianceDataPorExpirationDate & 
	ClientPropComplianceDataQuantranksConsent & 
	ClientPropComplianceDataQuantranksConsentDate & 
	ClientPropComplianceDataReAssessment & 
	ClientPropComplianceDataReAssessmentDate & 
	ClientPropComplianceDataRiskAccepted & 
	ClientPropComplianceDataRiskAcceptedDate & 
	ClientPropComplianceDataSharedealingConsent & 
	ClientPropComplianceDataSharedealingConsentDate & 
	ClientPropComplianceDataTaxJurisdiction & 
	ClientPropComplianceDataTaxJurisdiction2 & 
	ClientPropComplianceDataTermsAndConditionsAccepted & 
	ClientPropComplianceDataTermsAndConditionsAcceptedDate & 
	ClientPropComplianceDataTermsConditionsNewVersion & 
	ClientPropComplianceDataTermsConditionsNewVersionTime & 
	ClientPropComplianceDataTin & 
	ClientPropComplianceDataTin2 & 
	ClientPropComplianceDataTinAbsenceReason & 
	ClientPropComplianceDataW8Form & 
	ClientPropComplianceDataWhyCannotObtainTIN & 
	ClientPropComplianceDataWorldCheckFulfilled & 
	ClientPropCreationTime & 
	ClientPropCustomerAccountType & 
	ClientPropCustomerConcat & 
	ClientPropCustomerEntityType & 
	ClientPropCustomerFinancesLastActivityDate & 
	ClientPropCustomerFinancesTotalCancelledDepositsAmount & 
	ClientPropCustomerFinancesTotalCancelledDepositsCount & 
	ClientPropCustomerFinancesTotalDoneDepositsAmount & 
	ClientPropCustomerFinancesTotalDoneDepositsCount & 
	ClientPropCustomerFinancesTotalFailedDepositsAmount & 
	ClientPropCustomerFinancesTotalFailedDepositsCount & 
	ClientPropCustomerFinancesTotalPendingDepositsAmount & 
	ClientPropCustomerFinancesTotalPendingDepositsCount & 
	ClientPropCustomerLoginInfoPasswordCreationTime & 
	ClientPropCustomerStateEngagementState & 
	ClientPropCustomerStateModificationTime & 
	ClientPropCustomerStateNonEngagedType & 
	ClientPropDatePOA & 
	ClientPropDealingRisk & 
	ClientPropDescription & 
	ClientPropDisqualificationReason$list & 
	ClientPropDisqualificationReason$value & 
	ClientPropFinancialRisk & 
	ClientPropFirstRegistrationCountry & 
	ClientPropFullRegistration & 
	ClientPropId & 
	ClientPropInteractionLastLoginCountry & 
	ClientPropInteractionLastSource & 
	ClientPropInteractionLoginIp & 
	ClientPropInteractionModificationTime & 
	ClientPropIp & 
	ClientPropJointAccountReason & 
	ClientPropJointPrimaryOwner & 
	ClientPropLastRegistrationTime & 
	ClientPropLastWorldCheckIdIfMatched & 
	ClientPropLeverageLevels & 
	ClientPropLeverageTypeNames & 
	ClientPropLoginName & 
	ClientPropManager & 
	ClientPropModificationTime & 
	ClientPropModifiedBy & 
	ClientPropNpi & 
	ClientPropNpiType & 
	ClientPropNumberOfDeposits & 
	ClientPropNumberOfWithdrawals & 
	ClientPropOneClickClosingAccountStatus & 
	ClientPropOneClickClosingAccountStatusGround & 
	ClientPropOneClickClosingAccountStatusModificationTime & 
	ClientPropOwner & 
	ClientPropParentCustomerId & 
	ClientPropPartnerCompany & 
	ClientPropPartnerCompany$date & 
	ClientPropPartnerCompany$list & 
	ClientPropPartnerCompanyName & 
	ClientPropPassword & 
	ClientPropPendingBonusAmount & 
	ClientPropPendingBonusAmountUSD & 
	ClientPropPendingBonusCurrentPointsAmount & 
	ClientPropPendingBonusExpirationDate & 
	ClientPropPendingBonusStatus & 
	ClientPropPendingBonusTargetAmountOfPoints & 
	ClientPropPendingBonusTradingAccountId & 
	ClientPropPersonAddressAddress & 
	ClientPropPersonAddressAddress2 & 
	ClientPropPersonAddressCity & 
	ClientPropPersonAddressZipCode & 
	ClientPropPersonAgeGroup & 
	ClientPropPersonBirthDate & 
	ClientPropPersonCitizenship & 
	ClientPropPersonCountry & 
	ClientPropPersonCountry$list & 
	ClientPropPersonCountry$payload & 
	ClientPropPersonDriverLicense & 
	ClientPropPersonEmail1EmailAddress & 
	ClientPropPersonEmail1Verified & 
	ClientPropPersonEmail2EmailAddress & 
	ClientPropPersonEmail2Verified & 
	ClientPropPersonFirstName & 
	ClientPropPersonFirstNameEnglish & 
	ClientPropPersonGender & 
	ClientPropPersonIdNumber & 
	ClientPropPersonLanguage & 
	ClientPropPersonLanguageDbValue & 
	ClientPropPersonLastName & 
	ClientPropPersonLastNameEnglish & 
	ClientPropPersonLei & 
	ClientPropPersonLeiExpirationDate & 
	ClientPropPersonNameEnglish & 
	ClientPropPersonNationality & 
	ClientPropPersonPassport & 
	ClientPropPersonPhone1CountryCode & 
	ClientPropPersonPhone1Num & 
	ClientPropPersonPhone1Verified & 
	ClientPropPersonPhone2CountryCode & 
	ClientPropPersonPhone2Num & 
	ClientPropPersonPhone2Verified & 
	ClientPropPersonPhone4Num & 
	ClientPropPoiExpirationDays & 
	ClientPropPorExpirationDays & 
	ClientPropRealTradingAccountCount & 
	ClientPropRegistrationCompanySelection & 
	ClientPropRegistrationMarketingParamsCampaign & 
	ClientPropRegistrationMarketingParamsReferrer & 
	ClientPropRegistrationTrafficSourceAffiliateId & 
	ClientPropRegistrationTrafficSourceAffiliateId$affiliateRemark & 
	ClientPropRegistrationTrafficSourceLandingPage & 
	ClientPropRegistrationTrafficSourceMedia & 
	ClientPropRegistrationTrafficSourceNetwork & 
	ClientPropRegistrationTrafficSourcePromotionName & 
	ClientPropRegistrationTrafficSourceTrafficId & 
	ClientPropRegistrationTrafficSourceZone & 
	ClientPropRegistrationStatus & 
	ClientPropRegistrationsCount & 
	ClientPropRegulationTypeName & 
	ClientPropSecurityAnswer & 
	ClientPropSecurityQuestion & 
	ClientPropTotalDeposits & 
	ClientPropTotalWithdrawals & 
	ClientPropTradingTotalsRealEquity

export const CLIENT_PROPERTY_NAMES = Object.freeze([ClientProp.AssignedPoolName, ClientProp.AssignedUser, ClientProp.AvailableProducts, ClientProp.Blacklisted, ClientProp.BrandName, ClientProp.CompanyRegulationCountryCompanyRegulationGracePeriodScoreLevels, ClientProp.ComplianceDataAllowDeposits, ClientProp.ComplianceDataAmlClassificationStatus, ClientProp.ComplianceDataAmlCustomerQuestionnaireName, ClientProp.ComplianceDataAmlCustomerQuestionnaireQuestionnaireId, ClientProp.ComplianceDataAmlCustomerQuestionnaireScore, ClientProp.ComplianceDataAmlCustomerQuestionnaireScoreCategory, ClientProp.ComplianceDataClientClassification, ClientProp.ComplianceDataComment, ClientProp.ComplianceDataComplianceApprovedDate, ClientProp.ComplianceDataComplianceStage, ClientProp.ComplianceDataComplianceStage$list, ClientProp.ComplianceDataComplianceSuspendedGround, ClientProp.ComplianceDataComplianceSuspensionDate, ClientProp.ComplianceDataCustomerECDDPhone, ClientProp.ComplianceDataCustomerQuestionnaireFullyRegistered, ClientProp.ComplianceDataCustomerQuestionnaireName, ClientProp.ComplianceDataCustomerQuestionnaireQuestionnaireId, ClientProp.ComplianceDataCustomerQuestionnaireScore, ClientProp.ComplianceDataCustomerQuestionnaireScoreCategoryScoreLevel, ClientProp.ComplianceDataEcddOptions, ClientProp.ComplianceDataEcddPerformed, ClientProp.ComplianceDataEvAgreement, ClientProp.ComplianceDataEvAgreementDate, ClientProp.ComplianceDataFatca, ClientProp.ComplianceDataFirstDepositCountry, ClientProp.ComplianceDataFirstDepositCountry$payload, ClientProp.ComplianceDataFirstEyeApproved, ClientProp.ComplianceDataFirstEyeComplianceApprover, ClientProp.ComplianceDataFullRegistrationBonusTermsAndConditionsAccepted, ClientProp.ComplianceDataFullRegistrationIp, ClientProp.ComplianceDataGbgApproved, ClientProp.ComplianceDataGbgApprovedDate, ClientProp.ComplianceDataGbgApprovedStatus, ClientProp.ComplianceDataGbgAuthenticationId, ClientProp.ComplianceDataGracePeriodDuration, ClientProp.ComplianceDataGracePeriodEligible, ClientProp.ComplianceDataGracePeriodStatus, ClientProp.ComplianceDataHasLivenessTest, ClientProp.ComplianceDataHasProofOfId, ClientProp.ComplianceDataHasProofOfResidence, ClientProp.ComplianceDataLowScoreCautionAcceptedDate, ClientProp.ComplianceDataLowScoreWarningAccepted, ClientProp.ComplianceDataMediumScoreCautionAccepted, ClientProp.ComplianceDataMediumScoreCautionAcceptedDate, ClientProp.ComplianceDataNci, ClientProp.ComplianceDataNciStatus, ClientProp.ComplianceDataNewTradingAccountForbidden, ClientProp.ComplianceDataPendingComplianceGround, ClientProp.ComplianceDataPersonalInformationConfirmed, ClientProp.ComplianceDataPersonalInformationConfirmedDate, ClientProp.ComplianceDataPoiExpirationDate, ClientProp.ComplianceDataPoliticallyExposedPerson, ClientProp.ComplianceDataPorExpirationDate, ClientProp.ComplianceDataQuantranksConsent, ClientProp.ComplianceDataQuantranksConsentDate, ClientProp.ComplianceDataReAssessment, ClientProp.ComplianceDataReAssessmentDate, ClientProp.ComplianceDataRiskAccepted, ClientProp.ComplianceDataRiskAcceptedDate, ClientProp.ComplianceDataSharedealingConsent, ClientProp.ComplianceDataSharedealingConsentDate, ClientProp.ComplianceDataTaxJurisdiction, ClientProp.ComplianceDataTaxJurisdiction2, ClientProp.ComplianceDataTermsAndConditionsAccepted, ClientProp.ComplianceDataTermsAndConditionsAcceptedDate, ClientProp.ComplianceDataTermsConditionsNewVersion, ClientProp.ComplianceDataTermsConditionsNewVersionTime, ClientProp.ComplianceDataTin, ClientProp.ComplianceDataTin2, ClientProp.ComplianceDataTinAbsenceReason, ClientProp.ComplianceDataW8Form, ClientProp.ComplianceDataWhyCannotObtainTIN, ClientProp.ComplianceDataWorldCheckFulfilled, ClientProp.CreationTime, ClientProp.CustomerAccountType, ClientProp.CustomerConcat, ClientProp.CustomerEntityType, ClientProp.CustomerFinancesLastActivityDate, ClientProp.CustomerFinancesTotalCancelledDepositsAmount, ClientProp.CustomerFinancesTotalCancelledDepositsCount, ClientProp.CustomerFinancesTotalDoneDepositsAmount, ClientProp.CustomerFinancesTotalDoneDepositsCount, ClientProp.CustomerFinancesTotalFailedDepositsAmount, ClientProp.CustomerFinancesTotalFailedDepositsCount, ClientProp.CustomerFinancesTotalPendingDepositsAmount, ClientProp.CustomerFinancesTotalPendingDepositsCount, ClientProp.CustomerLoginInfoPasswordCreationTime, ClientProp.CustomerStateEngagementState, ClientProp.CustomerStateModificationTime, ClientProp.CustomerStateNonEngagedType, ClientProp.DatePOA, ClientProp.DealingRisk, ClientProp.Description, ClientProp.DisqualificationReason$list, ClientProp.DisqualificationReason$value, ClientProp.FinancialRisk, ClientProp.FirstRegistrationCountry, ClientProp.FullRegistration, ClientProp.Id, ClientProp.InteractionLastLoginCountry, ClientProp.InteractionLastSource, ClientProp.InteractionLoginIp, ClientProp.InteractionModificationTime, ClientProp.Ip, ClientProp.JointAccountReason, ClientProp.JointPrimaryOwner, ClientProp.LastRegistrationTime, ClientProp.LastWorldCheckIdIfMatched, ClientProp.LeverageLevels, ClientProp.LeverageTypeNames, ClientProp.LoginName, ClientProp.Manager, ClientProp.ModificationTime, ClientProp.ModifiedBy, ClientProp.Npi, ClientProp.NpiType, ClientProp.NumberOfDeposits, ClientProp.NumberOfWithdrawals, ClientProp.OneClickClosingAccountStatus, ClientProp.OneClickClosingAccountStatusGround, ClientProp.OneClickClosingAccountStatusModificationTime, ClientProp.Owner, ClientProp.ParentCustomerId, ClientProp.PartnerCompany, ClientProp.PartnerCompany$date, ClientProp.PartnerCompany$list, ClientProp.PartnerCompanyName, ClientProp.Password, ClientProp.PendingBonusAmount, ClientProp.PendingBonusAmountUSD, ClientProp.PendingBonusCurrentPointsAmount, ClientProp.PendingBonusExpirationDate, ClientProp.PendingBonusStatus, ClientProp.PendingBonusTargetAmountOfPoints, ClientProp.PendingBonusTradingAccountId, ClientProp.PersonAddressAddress, ClientProp.PersonAddressAddress2, ClientProp.PersonAddressCity, ClientProp.PersonAddressZipCode, ClientProp.PersonAgeGroup, ClientProp.PersonBirthDate, ClientProp.PersonCitizenship, ClientProp.PersonCountry, ClientProp.PersonCountry$list, ClientProp.PersonCountry$payload, ClientProp.PersonDriverLicense, ClientProp.PersonEmail1EmailAddress, ClientProp.PersonEmail1Verified, ClientProp.PersonEmail2EmailAddress, ClientProp.PersonEmail2Verified, ClientProp.PersonFirstName, ClientProp.PersonFirstNameEnglish, ClientProp.PersonGender, ClientProp.PersonIdNumber, ClientProp.PersonLanguage, ClientProp.PersonLanguageDbValue, ClientProp.PersonLastName, ClientProp.PersonLastNameEnglish, ClientProp.PersonLei, ClientProp.PersonLeiExpirationDate, ClientProp.PersonNameEnglish, ClientProp.PersonNationality, ClientProp.PersonPassport, ClientProp.PersonPhone1CountryCode, ClientProp.PersonPhone1Num, ClientProp.PersonPhone1Verified, ClientProp.PersonPhone2CountryCode, ClientProp.PersonPhone2Num, ClientProp.PersonPhone2Verified, ClientProp.PersonPhone4Num, ClientProp.PoiExpirationDays, ClientProp.PorExpirationDays, ClientProp.RealTradingAccountCount, ClientProp.RegistrationCompanySelection, ClientProp.RegistrationMarketingParamsCampaign, ClientProp.RegistrationMarketingParamsReferrer, ClientProp.RegistrationTrafficSourceAffiliateId, ClientProp.RegistrationTrafficSourceAffiliateId$affiliateRemark, ClientProp.RegistrationTrafficSourceLandingPage, ClientProp.RegistrationTrafficSourceMedia, ClientProp.RegistrationTrafficSourceNetwork, ClientProp.RegistrationTrafficSourcePromotionName, ClientProp.RegistrationTrafficSourceTrafficId, ClientProp.RegistrationTrafficSourceZone, ClientProp.RegistrationStatus, ClientProp.RegistrationsCount, ClientProp.RegulationTypeName, ClientProp.SecurityAnswer, ClientProp.SecurityQuestion, ClientProp.TotalDeposits, ClientProp.TotalWithdrawals, ClientProp.TradingTotalsRealEquity])

export type ClientTab = 
	ClientPropId & 
	ClientPropPersonFirstName & 
	ClientPropPersonLastName

export const CLIENT_TAB_PROPERTY_NAMES = Object.freeze([ClientProp.Id, ClientProp.PersonFirstName, ClientProp.PersonLastName])

export type ClientHistoryTab = 
	ClientPropId & 
	ClientPropPersonFirstName & 
	ClientPropPersonLastName

export const CLIENT_HISTORY_TAB_PROPERTY_NAMES = Object.freeze([ClientProp.Id, ClientProp.PersonFirstName, ClientProp.PersonLastName])

export type ClientAccountBalance = 
	ClientPropId & 
	ClientPropNumberOfDeposits & 
	ClientPropTotalDeposits & 
	ClientPropCustomerFinancesTotalDoneDepositsCount & 
	ClientPropCustomerFinancesTotalDoneDepositsAmount & 
	ClientPropCustomerFinancesTotalPendingDepositsCount & 
	ClientPropCustomerFinancesTotalPendingDepositsAmount & 
	ClientPropCustomerFinancesTotalFailedDepositsCount & 
	ClientPropCustomerFinancesTotalFailedDepositsAmount & 
	ClientPropCustomerFinancesTotalCancelledDepositsCount & 
	ClientPropCustomerFinancesTotalCancelledDepositsAmount & 
	ClientPropNumberOfWithdrawals & 
	ClientPropTotalWithdrawals & 
	ClientPropTradingTotalsRealEquity & 
	ClientPropRealTradingAccountCount & 
	ClientPropPendingBonusTradingAccountId & 
	ClientPropPendingBonusAmount & 
	ClientPropPendingBonusAmountUSD & 
	ClientPropPendingBonusExpirationDate & 
	ClientPropPendingBonusStatus & 
	ClientPropPendingBonusCurrentPointsAmount & 
	ClientPropPendingBonusTargetAmountOfPoints

export const CLIENT_ACCOUNT_BALANCE_PROPERTY_NAMES = Object.freeze([ClientProp.Id, ClientProp.NumberOfDeposits, ClientProp.TotalDeposits, ClientProp.CustomerFinancesTotalDoneDepositsCount, ClientProp.CustomerFinancesTotalDoneDepositsAmount, ClientProp.CustomerFinancesTotalPendingDepositsCount, ClientProp.CustomerFinancesTotalPendingDepositsAmount, ClientProp.CustomerFinancesTotalFailedDepositsCount, ClientProp.CustomerFinancesTotalFailedDepositsAmount, ClientProp.CustomerFinancesTotalCancelledDepositsCount, ClientProp.CustomerFinancesTotalCancelledDepositsAmount, ClientProp.NumberOfWithdrawals, ClientProp.TotalWithdrawals, ClientProp.TradingTotalsRealEquity, ClientProp.RealTradingAccountCount, ClientProp.PendingBonusTradingAccountId, ClientProp.PendingBonusAmount, ClientProp.PendingBonusAmountUSD, ClientProp.PendingBonusExpirationDate, ClientProp.PendingBonusStatus, ClientProp.PendingBonusCurrentPointsAmount, ClientProp.PendingBonusTargetAmountOfPoints])

export type ClientAccountDetails = 
	ClientPropId & 
	ClientPropParentCustomerId & 
	ClientPropInteractionModificationTime & 
	ClientPropInteractionLastSource & 
	ClientPropCustomerStateEngagementState & 
	ClientPropCustomerStateNonEngagedType & 
	ClientPropCustomerStateModificationTime & 
	ClientPropDisqualificationReason$value & 
	ClientPropOneClickClosingAccountStatus & 
	ClientPropOneClickClosingAccountStatusModificationTime & 
	ClientPropOneClickClosingAccountStatusGround & 
	ClientPropCreationTime & 
	ClientPropModificationTime & 
	ClientPropModifiedBy & 
	ClientPropRegistrationStatus & 
	ClientPropCustomerEntityType & 
	ClientPropCustomerAccountType & 
	ClientPropPartnerCompanyName & 
	ClientPropPartnerCompany & 
	ClientPropPartnerCompany$list & 
	ClientPropPartnerCompany$date & 
	ClientPropBrandName & 
	ClientPropRegulationTypeName & 
	ClientPropAssignedPoolName & 
	ClientPropAssignedUser & 
	ClientPropOwner & 
	ClientPropIp & 
	ClientPropFirstRegistrationCountry & 
	ClientPropComplianceDataFullRegistrationIp & 
	ClientPropInteractionLoginIp & 
	ClientPropInteractionLastLoginCountry & 
	ClientPropAvailableProducts & 
	ClientPropLeverageTypeNames & 
	ClientPropLeverageLevels & 
	ClientPropDescription & 
	ClientPropComplianceDataComment & 
	ClientPropCustomerFinancesLastActivityDate

export const CLIENT_ACCOUNT_DETAILS_PROPERTY_NAMES = Object.freeze([ClientProp.Id, ClientProp.ParentCustomerId, ClientProp.InteractionModificationTime, ClientProp.InteractionLastSource, ClientProp.CustomerStateEngagementState, ClientProp.CustomerStateNonEngagedType, ClientProp.CustomerStateModificationTime, ClientProp.DisqualificationReason$value, ClientProp.OneClickClosingAccountStatus, ClientProp.OneClickClosingAccountStatusModificationTime, ClientProp.OneClickClosingAccountStatusGround, ClientProp.CreationTime, ClientProp.ModificationTime, ClientProp.ModifiedBy, ClientProp.RegistrationStatus, ClientProp.CustomerEntityType, ClientProp.CustomerAccountType, ClientProp.PartnerCompanyName, ClientProp.PartnerCompany, ClientProp.PartnerCompany$list, ClientProp.PartnerCompany$date, ClientProp.BrandName, ClientProp.RegulationTypeName, ClientProp.AssignedPoolName, ClientProp.AssignedUser, ClientProp.Owner, ClientProp.Ip, ClientProp.FirstRegistrationCountry, ClientProp.ComplianceDataFullRegistrationIp, ClientProp.InteractionLoginIp, ClientProp.InteractionLastLoginCountry, ClientProp.AvailableProducts, ClientProp.LeverageTypeNames, ClientProp.LeverageLevels, ClientProp.Description, ClientProp.ComplianceDataComment, ClientProp.CustomerFinancesLastActivityDate])

export type ClientContactDetails = 
	ClientPropPersonPhone1CountryCode & 
	ClientPropPersonPhone1Verified & 
	ClientPropPersonPhone2CountryCode & 
	ClientPropPersonPhone2Verified & 
	ClientPropPersonEmail1EmailAddress & 
	ClientPropPersonEmail1Verified & 
	ClientPropPersonEmail2EmailAddress & 
	ClientPropPersonEmail2Verified

export const CLIENT_CONTACT_DETAILS_PROPERTY_NAMES = Object.freeze([ClientProp.PersonPhone1CountryCode, ClientProp.PersonPhone1Verified, ClientProp.PersonPhone2CountryCode, ClientProp.PersonPhone2Verified, ClientProp.PersonEmail1EmailAddress, ClientProp.PersonEmail1Verified, ClientProp.PersonEmail2EmailAddress, ClientProp.PersonEmail2Verified])

export type ClientClassification = 
	ClientPropId & 
	ClientPropComplianceDataClientClassification & 
	ClientPropCustomerStateModificationTime & 
	ClientPropModifiedBy & 
	ClientPropCustomerEntityType & 
	ClientPropCustomerAccountType & 
	ClientPropJointAccountReason & 
	ClientPropJointPrimaryOwner & 
	ClientPropManager & 
	ClientPropDatePOA & 
	ClientPropComplianceDataAmlClassificationStatus & 
	ClientPropCustomerConcat & 
	ClientPropNpiType & 
	ClientPropNpi

export const CLIENT_CLASSIFICATION_PROPERTY_NAMES = Object.freeze([ClientProp.Id, ClientProp.ComplianceDataClientClassification, ClientProp.CustomerStateModificationTime, ClientProp.ModifiedBy, ClientProp.CustomerEntityType, ClientProp.CustomerAccountType, ClientProp.JointAccountReason, ClientProp.JointPrimaryOwner, ClientProp.Manager, ClientProp.DatePOA, ClientProp.ComplianceDataAmlClassificationStatus, ClientProp.CustomerConcat, ClientProp.NpiType, ClientProp.Npi])

export type ClientECDD = 
	ClientPropComplianceDataEcddPerformed & 
	ClientPropComplianceDataFirstDepositCountry & 
	ClientPropComplianceDataFirstDepositCountry$payload & 
	ClientPropComplianceDataEcddOptions & 
	ClientPropComplianceDataCustomerECDDPhone

export const CLIENT_E_C_D_D_PROPERTY_NAMES = Object.freeze([ClientProp.ComplianceDataEcddPerformed, ClientProp.ComplianceDataFirstDepositCountry, ClientProp.ComplianceDataFirstDepositCountry$payload, ClientProp.ComplianceDataEcddOptions, ClientProp.ComplianceDataCustomerECDDPhone])

export type ClientEMIR = 
	ClientPropPersonLei & 
	ClientPropPersonLeiExpirationDate & 
	ClientPropCustomerEntityType

export const CLIENT_E_M_I_R_PROPERTY_NAMES = Object.freeze([ClientProp.PersonLei, ClientProp.PersonLeiExpirationDate, ClientProp.CustomerEntityType])

export type ClientAppropriatenessAssessment = 
	ClientPropId & 
	ClientPropComplianceDataCustomerQuestionnaireScore & 
	ClientPropComplianceDataCustomerQuestionnaireScoreCategoryScoreLevel & 
	ClientPropComplianceDataLowScoreWarningAccepted & 
	ClientPropComplianceDataLowScoreCautionAcceptedDate & 
	ClientPropComplianceDataMediumScoreCautionAccepted & 
	ClientPropComplianceDataMediumScoreCautionAcceptedDate & 
	ClientPropComplianceDataCustomerQuestionnaireQuestionnaireId & 
	ClientPropComplianceDataCustomerQuestionnaireName & 
	ClientPropComplianceDataCustomerQuestionnaireFullyRegistered & 
	ClientPropComplianceDataReAssessment & 
	ClientPropComplianceDataReAssessmentDate

export const CLIENT_APPROPRIATENESS_ASSESSMENT_PROPERTY_NAMES = Object.freeze([ClientProp.Id, ClientProp.ComplianceDataCustomerQuestionnaireScore, ClientProp.ComplianceDataCustomerQuestionnaireScoreCategoryScoreLevel, ClientProp.ComplianceDataLowScoreWarningAccepted, ClientProp.ComplianceDataLowScoreCautionAcceptedDate, ClientProp.ComplianceDataMediumScoreCautionAccepted, ClientProp.ComplianceDataMediumScoreCautionAcceptedDate, ClientProp.ComplianceDataCustomerQuestionnaireQuestionnaireId, ClientProp.ComplianceDataCustomerQuestionnaireName, ClientProp.ComplianceDataCustomerQuestionnaireFullyRegistered, ClientProp.ComplianceDataReAssessment, ClientProp.ComplianceDataReAssessmentDate])

export type ClientAntiMoneyLaundering = 
	ClientPropId & 
	ClientPropComplianceDataAmlCustomerQuestionnaireScore & 
	ClientPropComplianceDataAmlCustomerQuestionnaireScoreCategory & 
	ClientPropComplianceDataAmlCustomerQuestionnaireQuestionnaireId & 
	ClientPropComplianceDataAmlCustomerQuestionnaireName

export const CLIENT_ANTI_MONEY_LAUNDERING_PROPERTY_NAMES = Object.freeze([ClientProp.Id, ClientProp.ComplianceDataAmlCustomerQuestionnaireScore, ClientProp.ComplianceDataAmlCustomerQuestionnaireScoreCategory, ClientProp.ComplianceDataAmlCustomerQuestionnaireQuestionnaireId, ClientProp.ComplianceDataAmlCustomerQuestionnaireName])

export type ClientAgreements = 
	ClientPropId & 
	ClientPropComplianceDataTermsAndConditionsAccepted & 
	ClientPropComplianceDataTermsAndConditionsAcceptedDate & 
	ClientPropComplianceDataPersonalInformationConfirmed & 
	ClientPropComplianceDataPersonalInformationConfirmedDate & 
	ClientPropComplianceDataTermsConditionsNewVersion & 
	ClientPropComplianceDataTermsConditionsNewVersionTime & 
	ClientPropComplianceDataFullRegistrationBonusTermsAndConditionsAccepted & 
	ClientPropComplianceDataQuantranksConsent & 
	ClientPropComplianceDataQuantranksConsentDate & 
	ClientPropComplianceDataSharedealingConsent & 
	ClientPropComplianceDataSharedealingConsentDate & 
	ClientPropComplianceDataRiskAccepted & 
	ClientPropComplianceDataRiskAcceptedDate

export const CLIENT_AGREEMENTS_PROPERTY_NAMES = Object.freeze([ClientProp.Id, ClientProp.ComplianceDataTermsAndConditionsAccepted, ClientProp.ComplianceDataTermsAndConditionsAcceptedDate, ClientProp.ComplianceDataPersonalInformationConfirmed, ClientProp.ComplianceDataPersonalInformationConfirmedDate, ClientProp.ComplianceDataTermsConditionsNewVersion, ClientProp.ComplianceDataTermsConditionsNewVersionTime, ClientProp.ComplianceDataFullRegistrationBonusTermsAndConditionsAccepted, ClientProp.ComplianceDataQuantranksConsent, ClientProp.ComplianceDataQuantranksConsentDate, ClientProp.ComplianceDataSharedealingConsent, ClientProp.ComplianceDataSharedealingConsentDate, ClientProp.ComplianceDataRiskAccepted, ClientProp.ComplianceDataRiskAcceptedDate])

export type ClientHeader = 
	ClientPropPersonFirstName & 
	ClientPropPersonLastName & 
	ClientPropId & 
	ClientPropParentCustomerId & 
	ClientPropPartnerCompanyName & 
	ClientPropBrandName & 
	ClientPropComplianceDataComplianceStage & 
	ClientPropPersonCountry & 
	ClientPropTradingTotalsRealEquity & 
	ClientPropOneClickClosingAccountStatus

export const CLIENT_HEADER_PROPERTY_NAMES = Object.freeze([ClientProp.PersonFirstName, ClientProp.PersonLastName, ClientProp.Id, ClientProp.ParentCustomerId, ClientProp.PartnerCompanyName, ClientProp.BrandName, ClientProp.ComplianceDataComplianceStage, ClientProp.PersonCountry, ClientProp.TradingTotalsRealEquity, ClientProp.OneClickClosingAccountStatus])

export type ClientJointAccounts = 
	ClientPropJointAccountReason & 
	ClientPropJointPrimaryOwner & 
	ClientPropManager & 
	ClientPropDatePOA & 
	ClientPropCustomerAccountType

export const CLIENT_JOINT_ACCOUNTS_PROPERTY_NAMES = Object.freeze([ClientProp.JointAccountReason, ClientProp.JointPrimaryOwner, ClientProp.Manager, ClientProp.DatePOA, ClientProp.CustomerAccountType])

export type ClientPersonalInformation = 
	ClientPropPersonFirstName & 
	ClientPropPersonLastName & 
	ClientPropPersonFirstNameEnglish & 
	ClientPropPersonLastNameEnglish & 
	ClientPropPersonLanguage & 
	ClientPropPersonLanguageDbValue & 
	ClientPropPersonGender & 
	ClientPropPersonBirthDate & 
	ClientPropPersonAgeGroup & 
	ClientPropPersonCitizenship & 
	ClientPropPersonNationality & 
	ClientPropPersonCountry & 
	ClientPropPersonCountry$list & 
	ClientPropPersonAddressCity & 
	ClientPropPersonAddressAddress & 
	ClientPropPersonAddressAddress2 & 
	ClientPropPersonAddressZipCode

export const CLIENT_PERSONAL_INFORMATION_PROPERTY_NAMES = Object.freeze([ClientProp.PersonFirstName, ClientProp.PersonLastName, ClientProp.PersonFirstNameEnglish, ClientProp.PersonLastNameEnglish, ClientProp.PersonLanguage, ClientProp.PersonLanguageDbValue, ClientProp.PersonGender, ClientProp.PersonBirthDate, ClientProp.PersonAgeGroup, ClientProp.PersonCitizenship, ClientProp.PersonNationality, ClientProp.PersonCountry, ClientProp.PersonCountry$list, ClientProp.PersonAddressCity, ClientProp.PersonAddressAddress, ClientProp.PersonAddressAddress2, ClientProp.PersonAddressZipCode])

export type ClientSecretFields = 
	ClientPropPersonPhone1Num & 
	ClientPropPersonPhone2Num & 
	ClientPropPersonPhone4Num & 
	ClientPropPersonEmail1EmailAddress & 
	ClientPropPersonEmail2EmailAddress & 
	ClientPropLoginName & 
	ClientPropPassword

export const CLIENT_SECRET_FIELDS_PROPERTY_NAMES = Object.freeze([ClientProp.PersonPhone1Num, ClientProp.PersonPhone2Num, ClientProp.PersonPhone4Num, ClientProp.PersonEmail1EmailAddress, ClientProp.PersonEmail2EmailAddress, ClientProp.LoginName, ClientProp.Password])

export type ClientSummary = 
	ClientPropPersonFirstName & 
	ClientPropPersonLastName & 
	ClientPropId & 
	ClientPropParentCustomerId & 
	ClientPropInteractionModificationTime & 
	ClientPropInteractionLastSource & 
	ClientPropCustomerStateEngagementState & 
	ClientPropCustomerStateNonEngagedType & 
	ClientPropCustomerStateModificationTime & 
	ClientPropDisqualificationReason$value & 
	ClientPropOneClickClosingAccountStatus & 
	ClientPropCreationTime & 
	ClientPropModificationTime & 
	ClientPropModifiedBy & 
	ClientPropOneClickClosingAccountStatusGround & 
	ClientPropOneClickClosingAccountStatusModificationTime & 
	ClientPropRegistrationStatus & 
	ClientPropCustomerEntityType & 
	ClientPropCustomerAccountType & 
	ClientPropPartnerCompanyName & 
	ClientPropBrandName & 
	ClientPropRegulationTypeName & 
	ClientPropAssignedPoolName & 
	ClientPropAssignedUser & 
	ClientPropAvailableProducts & 
	ClientPropLeverageTypeNames & 
	ClientPropLeverageLevels & 
	ClientPropPersonNameEnglish & 
	ClientPropPersonLanguage & 
	ClientPropPersonCitizenship & 
	ClientPropPersonNationality & 
	ClientPropPersonCountry & 
	ClientPropPersonCountry$payload & 
	ClientPropComplianceDataComplianceStage & 
	ClientPropComplianceDataComplianceApprovedDate & 
	ClientPropComplianceDataGbgApprovedStatus & 
	ClientPropComplianceDataHasProofOfId & 
	ClientPropComplianceDataHasProofOfResidence & 
	ClientPropComplianceDataClientClassification & 
	ClientPropComplianceDataTaxJurisdiction & 
	ClientPropComplianceDataTaxJurisdiction2 & 
	ClientPropComplianceDataFatca & 
	ClientPropComplianceDataCustomerQuestionnaireScore & 
	ClientPropComplianceDataCustomerQuestionnaireScoreCategoryScoreLevel & 
	ClientPropFullRegistration & 
	ClientPropComplianceDataAmlCustomerQuestionnaireScore & 
	ClientPropComplianceDataAmlCustomerQuestionnaireScoreCategory & 
	ClientPropComplianceDataWorldCheckFulfilled

export const CLIENT_SUMMARY_PROPERTY_NAMES = Object.freeze([ClientProp.PersonFirstName, ClientProp.PersonLastName, ClientProp.Id, ClientProp.ParentCustomerId, ClientProp.InteractionModificationTime, ClientProp.InteractionLastSource, ClientProp.CustomerStateEngagementState, ClientProp.CustomerStateNonEngagedType, ClientProp.CustomerStateModificationTime, ClientProp.DisqualificationReason$value, ClientProp.OneClickClosingAccountStatus, ClientProp.CreationTime, ClientProp.ModificationTime, ClientProp.ModifiedBy, ClientProp.OneClickClosingAccountStatusGround, ClientProp.OneClickClosingAccountStatusModificationTime, ClientProp.RegistrationStatus, ClientProp.CustomerEntityType, ClientProp.CustomerAccountType, ClientProp.PartnerCompanyName, ClientProp.BrandName, ClientProp.RegulationTypeName, ClientProp.AssignedPoolName, ClientProp.AssignedUser, ClientProp.AvailableProducts, ClientProp.LeverageTypeNames, ClientProp.LeverageLevels, ClientProp.PersonNameEnglish, ClientProp.PersonLanguage, ClientProp.PersonCitizenship, ClientProp.PersonNationality, ClientProp.PersonCountry, ClientProp.PersonCountry$payload, ClientProp.ComplianceDataComplianceStage, ClientProp.ComplianceDataComplianceApprovedDate, ClientProp.ComplianceDataGbgApprovedStatus, ClientProp.ComplianceDataHasProofOfId, ClientProp.ComplianceDataHasProofOfResidence, ClientProp.ComplianceDataClientClassification, ClientProp.ComplianceDataTaxJurisdiction, ClientProp.ComplianceDataTaxJurisdiction2, ClientProp.ComplianceDataFatca, ClientProp.ComplianceDataCustomerQuestionnaireScore, ClientProp.ComplianceDataCustomerQuestionnaireScoreCategoryScoreLevel, ClientProp.FullRegistration, ClientProp.ComplianceDataAmlCustomerQuestionnaireScore, ClientProp.ComplianceDataAmlCustomerQuestionnaireScoreCategory, ClientProp.ComplianceDataWorldCheckFulfilled])

export type ClientTabRegulatory = 
	ClientPropComplianceDataTin & 
	ClientPropComplianceDataNci & 
	ClientPropPersonCitizenship & 
	ClientPropPersonLeiExpirationDate & 
	ClientPropCustomerEntityType

export const CLIENT_TAB_REGULATORY_PROPERTY_NAMES = Object.freeze([ClientProp.ComplianceDataTin, ClientProp.ComplianceDataNci, ClientProp.PersonCitizenship, ClientProp.PersonLeiExpirationDate, ClientProp.CustomerEntityType])

export type ClientTaxInformation = 
	ClientPropComplianceDataTaxJurisdiction & 
	ClientPropComplianceDataTaxJurisdiction2 & 
	ClientPropComplianceDataFatca & 
	ClientPropComplianceDataTin & 
	ClientPropComplianceDataTin2 & 
	ClientPropComplianceDataTinAbsenceReason & 
	ClientPropComplianceDataWhyCannotObtainTIN & 
	ClientPropComplianceDataNci & 
	ClientPropComplianceDataNciStatus & 
	ClientPropComplianceDataW8Form & 
	ClientPropPersonCitizenship & 
	ClientPropPersonIdNumber & 
	ClientPropPersonPassport & 
	ClientPropPersonDriverLicense & 
	ClientPropPersonLei & 
	ClientPropCustomerConcat & 
	ClientPropCustomerEntityType

export const CLIENT_TAX_INFORMATION_PROPERTY_NAMES = Object.freeze([ClientProp.ComplianceDataTaxJurisdiction, ClientProp.ComplianceDataTaxJurisdiction2, ClientProp.ComplianceDataFatca, ClientProp.ComplianceDataTin, ClientProp.ComplianceDataTin2, ClientProp.ComplianceDataTinAbsenceReason, ClientProp.ComplianceDataWhyCannotObtainTIN, ClientProp.ComplianceDataNci, ClientProp.ComplianceDataNciStatus, ClientProp.ComplianceDataW8Form, ClientProp.PersonCitizenship, ClientProp.PersonIdNumber, ClientProp.PersonPassport, ClientProp.PersonDriverLicense, ClientProp.PersonLei, ClientProp.CustomerConcat, ClientProp.CustomerEntityType])

export type ClientVerification = 
	ClientPropId & 
	ClientPropComplianceDataComplianceStage & 
	ClientPropComplianceDataComplianceStage$list & 
	ClientPropComplianceDataComplianceApprovedDate & 
	ClientPropComplianceDataPendingComplianceGround & 
	ClientPropComplianceDataComplianceSuspendedGround & 
	ClientPropComplianceDataComplianceSuspensionDate & 
	ClientPropComplianceDataAllowDeposits & 
	ClientPropComplianceDataNewTradingAccountForbidden & 
	ClientPropPersonIdNumber & 
	ClientPropPersonPassport & 
	ClientPropPersonDriverLicense & 
	ClientPropComplianceDataGbgApproved & 
	ClientPropComplianceDataGbgApprovedStatus & 
	ClientPropComplianceDataHasLivenessTest & 
	ClientPropComplianceDataGbgApprovedDate & 
	ClientPropComplianceDataGbgAuthenticationId & 
	ClientPropComplianceDataEvAgreement & 
	ClientPropComplianceDataEvAgreementDate & 
	ClientPropComplianceDataHasProofOfId & 
	ClientPropComplianceDataPoiExpirationDate & 
	ClientPropPoiExpirationDays & 
	ClientPropComplianceDataHasProofOfResidence & 
	ClientPropComplianceDataPorExpirationDate & 
	ClientPropPorExpirationDays & 
	ClientPropComplianceDataGracePeriodEligible & 
	ClientPropComplianceDataGracePeriodStatus & 
	ClientPropComplianceDataGracePeriodDuration & 
	ClientPropComplianceDataFirstEyeApproved & 
	ClientPropComplianceDataFirstEyeComplianceApprover & 
	ClientPropComplianceDataFatca & 
	ClientPropComplianceDataW8Form & 
	ClientPropCompanyRegulationCountryCompanyRegulationGracePeriodScoreLevels & 
	ClientPropComplianceDataAmlCustomerQuestionnaireScoreCategory

export const CLIENT_VERIFICATION_PROPERTY_NAMES = Object.freeze([ClientProp.Id, ClientProp.ComplianceDataComplianceStage, ClientProp.ComplianceDataComplianceStage$list, ClientProp.ComplianceDataComplianceApprovedDate, ClientProp.ComplianceDataPendingComplianceGround, ClientProp.ComplianceDataComplianceSuspendedGround, ClientProp.ComplianceDataComplianceSuspensionDate, ClientProp.ComplianceDataAllowDeposits, ClientProp.ComplianceDataNewTradingAccountForbidden, ClientProp.PersonIdNumber, ClientProp.PersonPassport, ClientProp.PersonDriverLicense, ClientProp.ComplianceDataGbgApproved, ClientProp.ComplianceDataGbgApprovedStatus, ClientProp.ComplianceDataHasLivenessTest, ClientProp.ComplianceDataGbgApprovedDate, ClientProp.ComplianceDataGbgAuthenticationId, ClientProp.ComplianceDataEvAgreement, ClientProp.ComplianceDataEvAgreementDate, ClientProp.ComplianceDataHasProofOfId, ClientProp.ComplianceDataPoiExpirationDate, ClientProp.PoiExpirationDays, ClientProp.ComplianceDataHasProofOfResidence, ClientProp.ComplianceDataPorExpirationDate, ClientProp.PorExpirationDays, ClientProp.ComplianceDataGracePeriodEligible, ClientProp.ComplianceDataGracePeriodStatus, ClientProp.ComplianceDataGracePeriodDuration, ClientProp.ComplianceDataFirstEyeApproved, ClientProp.ComplianceDataFirstEyeComplianceApprover, ClientProp.ComplianceDataFatca, ClientProp.ComplianceDataW8Form, ClientProp.CompanyRegulationCountryCompanyRegulationGracePeriodScoreLevels, ClientProp.ComplianceDataAmlCustomerQuestionnaireScoreCategory])

export type ClientWorldCheck = 
	ClientPropComplianceDataWorldCheckFulfilled & 
	ClientPropComplianceDataPoliticallyExposedPerson & 
	ClientPropLastWorldCheckIdIfMatched

export const CLIENT_WORLD_CHECK_PROPERTY_NAMES = Object.freeze([ClientProp.ComplianceDataWorldCheckFulfilled, ClientProp.ComplianceDataPoliticallyExposedPerson, ClientProp.LastWorldCheckIdIfMatched])

export type ClientInfo = 
	ClientPropPersonFirstName & 
	ClientPropPersonLastName & 
	ClientPropPersonFirstNameEnglish & 
	ClientPropPersonLastNameEnglish & 
	ClientPropPersonLanguage & 
	ClientPropPersonLanguageDbValue & 
	ClientPropPersonGender & 
	ClientPropPersonBirthDate & 
	ClientPropPersonIdNumber & 
	ClientPropPersonLei & 
	ClientPropPersonPassport & 
	ClientPropPersonCitizenship & 
	ClientPropPersonCountry & 
	ClientPropPersonCountry$list & 
	ClientPropPersonAddressCity & 
	ClientPropPersonAddressAddress & 
	ClientPropPersonAddressAddress2 & 
	ClientPropPersonAddressZipCode & 
	ClientPropPersonPhone1CountryCode & 
	ClientPropPersonPhone2CountryCode & 
	ClientPropComplianceDataNci & 
	ClientPropComplianceDataNciStatus & 
	ClientPropComplianceDataTaxJurisdiction & 
	ClientPropComplianceDataTin & 
	ClientPropComplianceDataTaxJurisdiction2 & 
	ClientPropComplianceDataTin2 & 
	ClientPropComplianceDataTinAbsenceReason & 
	ClientPropComplianceDataWhyCannotObtainTIN & 
	ClientPropComplianceDataEcddPerformed & 
	ClientPropComplianceDataEcddOptions & 
	ClientPropCustomerEntityType

export const CLIENT_INFO_PROPERTY_NAMES = Object.freeze([ClientProp.PersonFirstName, ClientProp.PersonLastName, ClientProp.PersonFirstNameEnglish, ClientProp.PersonLastNameEnglish, ClientProp.PersonLanguage, ClientProp.PersonLanguageDbValue, ClientProp.PersonGender, ClientProp.PersonBirthDate, ClientProp.PersonIdNumber, ClientProp.PersonLei, ClientProp.PersonPassport, ClientProp.PersonCitizenship, ClientProp.PersonCountry, ClientProp.PersonCountry$list, ClientProp.PersonAddressCity, ClientProp.PersonAddressAddress, ClientProp.PersonAddressAddress2, ClientProp.PersonAddressZipCode, ClientProp.PersonPhone1CountryCode, ClientProp.PersonPhone2CountryCode, ClientProp.ComplianceDataNci, ClientProp.ComplianceDataNciStatus, ClientProp.ComplianceDataTaxJurisdiction, ClientProp.ComplianceDataTin, ClientProp.ComplianceDataTaxJurisdiction2, ClientProp.ComplianceDataTin2, ClientProp.ComplianceDataTinAbsenceReason, ClientProp.ComplianceDataWhyCannotObtainTIN, ClientProp.ComplianceDataEcddPerformed, ClientProp.ComplianceDataEcddOptions, ClientProp.CustomerEntityType])

export type ClientTrafficSource = 
	ClientPropId & 
	ClientPropRegistrationTrafficSourceAffiliateId & 
	ClientPropRegistrationMarketingParamsCampaign & 
	ClientPropRegistrationTrafficSourceNetwork & 
	ClientPropRegistrationTrafficSourceMedia & 
	ClientPropRegistrationTrafficSourceAffiliateId$affiliateRemark & 
	ClientPropRegistrationTrafficSourceZone & 
	ClientPropRegistrationTrafficSourceTrafficId & 
	ClientPropRegistrationTrafficSourceLandingPage & 
	ClientPropRegistrationMarketingParamsReferrer & 
	ClientPropRegistrationTrafficSourcePromotionName & 
	ClientPropRegistrationCompanySelection & 
	ClientPropRegistrationsCount & 
	ClientPropLastRegistrationTime

export const CLIENT_TRAFFIC_SOURCE_PROPERTY_NAMES = Object.freeze([ClientProp.Id, ClientProp.RegistrationTrafficSourceAffiliateId, ClientProp.RegistrationMarketingParamsCampaign, ClientProp.RegistrationTrafficSourceNetwork, ClientProp.RegistrationTrafficSourceMedia, ClientProp.RegistrationTrafficSourceAffiliateId$affiliateRemark, ClientProp.RegistrationTrafficSourceZone, ClientProp.RegistrationTrafficSourceTrafficId, ClientProp.RegistrationTrafficSourceLandingPage, ClientProp.RegistrationMarketingParamsReferrer, ClientProp.RegistrationTrafficSourcePromotionName, ClientProp.RegistrationCompanySelection, ClientProp.RegistrationsCount, ClientProp.LastRegistrationTime])

export type ClientSecurity = 
	ClientPropId & 
	ClientPropLoginName & 
	ClientPropPassword & 
	ClientPropSecurityQuestion & 
	ClientPropSecurityAnswer & 
	ClientPropCustomerLoginInfoPasswordCreationTime

export const CLIENT_SECURITY_PROPERTY_NAMES = Object.freeze([ClientProp.Id, ClientProp.LoginName, ClientProp.Password, ClientProp.SecurityQuestion, ClientProp.SecurityAnswer, ClientProp.CustomerLoginInfoPasswordCreationTime])

export type ClientRisks = 
	ClientPropId & 
	ClientPropFinancialRisk & 
	ClientPropDealingRisk & 
	ClientPropBlacklisted & 
	ClientPropComplianceDataAllowDeposits & 
	ClientPropComplianceDataNewTradingAccountForbidden & 
	ClientPropDisqualificationReason$list

export const CLIENT_RISKS_PROPERTY_NAMES = Object.freeze([ClientProp.Id, ClientProp.FinancialRisk, ClientProp.DealingRisk, ClientProp.Blacklisted, ClientProp.ComplianceDataAllowDeposits, ClientProp.ComplianceDataNewTradingAccountForbidden, ClientProp.DisqualificationReason$list])

export type ClientTradingAccounts = 
	ClientPropPersonFirstName & 
	ClientPropPersonLastName & 
	ClientPropLeverageLevels

export const CLIENT_TRADING_ACCOUNTS_PROPERTY_NAMES = Object.freeze([ClientProp.PersonFirstName, ClientProp.PersonLastName, ClientProp.LeverageLevels])
